const translations = {
  en: {
    // Sidebar Groups
    "nav.overview": "Overview", "nav.compliance": "Compliance", "nav.risk_threats": "Risk & Threats",
    "nav.governance": "Governance", "nav.organization": "Organization", "nav.reports": "Reports & Analytics",
    "nav.ai_tools": "AI Tools", "nav.settings": "Settings",
    // Nav Items
    "nav.dashboard": "Dashboard", "nav.calendar": "Calendar", "nav.controls": "Control Library",
    "nav.soa": "Statement of Applicability", "nav.gap_analysis": "Gap Analysis",
    "nav.certification": "Certification Readiness", "nav.mappings": "Framework Mappings",
    "nav.risks": "Risk Register", "nav.heatmap": "Risk Heat Map",
    "nav.threat_intel": "Threat Intelligence", "nav.vuln_scanner": "Vulnerability Scanner",
    "nav.risk_predictor": "AI Risk Intelligence", "nav.documents": "Documents",
    "nav.evidence": "Evidence", "nav.audits": "Internal Audits",
    "nav.mgmt_review": "Management Review", "nav.corrective_actions": "Corrective Actions",
    "nav.incidents": "Incidents", "nav.vendors": "Vendor Risk",
    "nav.training": "Training & Awareness", "nav.maintenance": "Maintenance",
    "nav.reports_export": "Reports & Export", "nav.exec_report": "Executive Report",
    "nav.benchmarking": "Benchmarking", "nav.policy_gen": "Policy Generator",
    "nav.wizard": "Implementation Wizard", "nav.email": "Email Settings",
    "nav.rbac": "Access Control", "nav.tenants": "Multi-Tenancy", "nav.billing": "Billing",
    "nav.esignature": "Electronic Signature", "nav.frameworks": "Frameworks",
    "nav.platform_admin": "Platform Admin",
    "nav.portal": "Client Portal", "nav.bulk": "Bulk Import/Export",
    "nav.evidence_collection": "Auto Evidence",
    "nav.zona_franca": "Zona Franca",
    "nav.zf_overview": "ZF Overview", "nav.zf_oea": "OEA", "nav.zf_cnzfe": "CNZFE 522-06",
    "nav.zf_iso22000": "ISO 22000", "nav.zf_bpm": "BPM", "nav.zf_haccp": "HACCP",
    "nav.zf_nordom477": "NORDOM 477",
    // UX strings — added during ES consistency pass
    "ux.no_projects_yet": "No projects yet. Create one to start working per client.",
    "ux.published": "Published", "ux.draft": "Draft", "ux.archived": "Archived",
    "ux.framework_compliance": "Framework Compliance",
    "ux.corrective_actions": "Corrective Actions",
    "ux.risk_posture": "Risk Posture",
    "ux.maintenance": "Maintenance",
    "ux.incident_resolution": "Incident Resolution",
    "ux.compliance_score_trend": "Compliance Score Trend",
    "ux.compliance_score_trend_desc": "Framework compliance scores over the last 90 days",
    "ux.total_risks": "Total Risks",
    "ux.showing_of_controls": "Showing {x} of {y} controls",
    "ux.organizational": "Organizational",
    "ux.risk_distribution": "Risk Distribution",
    "ux.incident_summary": "Incident Summary",
    "ux.likelihood_vs_impact": "Likelihood vs Impact Matrix",
    "ux.click_cell_hint": "Click a cell to see risks at that position",
    "ux.likelihood": "Likelihood", "ux.impact": "Impact",
    "ux.clear_filters": "Clear Filters",
    "ux.upgrade_to_pro": "Available in Professional plan",
    "ux.upgrade_cta": "View plans",
    // Health Score breakdown labels (keys match backend health-score.breakdown ids)
    "health.compliance": "Framework Compliance",
    "health.corrective_actions": "Corrective Actions",
    "health.risk_posture": "Risk Posture",
    "health.maintenance": "Maintenance",
    "health.incidents": "Incident Resolution",
    // Common
    "save": "Save", "cancel": "Cancel", "delete": "Delete", "create": "Create", "edit": "Edit",
    "search": "Search", "filter": "Filter", "export": "Export", "import": "Import",
    "loading": "Loading...", "no_data": "No data available", "status": "Status",
    "actions": "Actions", "all": "All", "active": "Active", "completed": "Completed",
    "open": "Open", "closed": "Closed", "yes": "Yes", "no": "No", "back": "Back",
    "next": "Next", "submit": "Submit", "download": "Download", "copy": "Copy",
    "copied": "Copied", "generate": "Generate", "generating": "Generating...",
    "new": "New", "add": "Add", "remove": "Remove", "update": "Update",
    "details": "Details", "description": "Description", "title": "Title",
    "notes": "Notes", "optional": "Optional",
    "date": "Date", "owner": "Owner", "priority": "Priority", "category": "Category",
    "type": "Type", "total": "Total", "score": "Score", "name": "Name",
    "email_label": "Email", "password": "Password", "confirm": "Confirm",
    "critical": "Critical", "high": "High", "medium": "Medium", "low": "Low", "moderate": "Moderate",
    "in_progress": "In Progress", "not_started": "Not Started", "overdue": "Overdue",
    "implemented": "Implemented", "not_applicable": "Not Applicable", "pending": "Pending",
    "paused": "Paused",
    // Auth
    "auth.sign_in": "Sign In", "auth.sign_up": "Sign Up", "auth.email": "Email",
    "auth.password": "Password", "auth.name": "Full Name", "auth.org_name": "Organization Name",
    "auth.back_to_home": "Back to Home", "auth.signing_in": "Signing in...",
    "auth.logout": "Log Out", "auth.welcome": "Welcome to ComplianceOS",
    "auth.subtitle": "Multi-Framework Compliance Management Platform",
    "auth.no_account": "Don't have an account?", "auth.have_account": "Already have an account?",
    "auth.or_continue": "Or continue with", "auth.google": "Continue with Google",
    // Language
    "lang.title": "Language", "lang.en": "English", "lang.es": "Spanish",
    // Dashboard labels
    "dashboard.loading": "Loading dashboard...",
    "dashboard.total_risks": "Total Risks",
    "dashboard.new": "New", "dashboard.investigating": "Investigating", "dashboard.closed": "Closed",
    "dashboard.trend_placeholder": "Trend data will appear as compliance scores are recorded",
    "dashboard.documents": "Documents", "dashboard.assets_tracked": "Assets Tracked",
    "dashboard.compliance_status": "Compliance Status",
    "dashboard.on_track": "On Track", "dashboard.needs_attention": "Needs Attention",
    "dashboard.critical": "Critical",
    // Controls / Mappings / Docs
    "ctrl.list_title": "Control Library", "ctrl.list_subtitle": "Browse all compliance controls across frameworks",
    "ctrl.total": "Total Controls", "ctrl.framework": "Framework",
    "docs.title": "Documents", "docs.subtitle": "Manage policies, procedures, and compliance documents",
    "docs.upload": "Upload Document",
    "inc.title": "Incidents", "inc.subtitle": "Track and manage security incidents",
    "inc.new": "Report Incident",
    "audits.title": "Internal Audits", "audits.subtitle": "Plan, execute and track internal compliance audits",
    "audits.new": "New Audit",
    // Evidence
    "evid.title": "Evidence Repository", "evid.subtitle": "Centralized evidence library for audits and compliance",
    "evid.new": "Add Evidence",
    // Management Review
    "mr.title": "Management Review", "mr.subtitle": "ISO-compliant leadership reviews of the compliance system",
    "mr.new": "New Review",
    "mr.loading": "Loading management reviews...",
    "mr.schedule_first": "Schedule Your First Review",
    "mr.title_placeholder": "e.g., Q1 2026 ISMS Management Review",
    "mr.agenda_default_hint": "Agenda Items (default items will be used if empty)",
    "mr.change_status": "Change Status",
    "mr.system_inputs": "System Inputs (Auto-populated)",
    "mr.compliance_score": "Compliance Score",
    "mr.open_ncs": "Open NCs",
    "mr.recent_incidents": "Recent Incidents",
    "mr.assets_tracked": "Assets Tracked",
    "mr.agenda_label": "Agenda Items",
    "mr.decisions_made": "Decisions Made",
    "mr.no_decisions": "No decisions recorded yet",
    "mr.add_decision_ph": "Add a decision...",
    "mr.owner": "Owner",
    "mr.due": "Due",
    "mr.action_items": "Action Items",
    "mr.no_action_items": "No action items yet",
    "mr.action_desc_ph": "Action item description...",
    "mr.action_owner_ph": "Owner",
    "mr.attendees": "attendees",
    "mr.action_items_count": "action items",
    // Management Review agenda preview keys (mirror DEFAULT_AGENDA_BY_LOCALE on backend)
    "mr.agenda.isms_performance": "Review of ISMS/SMS performance",
    "mr.agenda.ca_status": "Status of corrective actions",
    "mr.agenda.changes": "Changes affecting the management system",
    "mr.agenda.improvements": "Opportunities for improvement",
    "mr.agenda.resources": "Resource requirements",
    "mr.agenda.risk_review": "Risk assessment review",
    // Management Review toasts
    "mr.toast.title_date_required": "Please enter a title and date",
    "mr.toast.created": "Management review created",
    "mr.toast.create_failed": "Failed to create review",
    "mr.toast.status_updated": "Status updated",
    "mr.toast.status_failed": "Failed to update status",
    "mr.toast.decision_added": "Decision added",
    "mr.toast.decision_failed": "Failed to add decision",
    "mr.toast.action_added": "Action item added",
    "mr.toast.action_failed": "Failed to add action item",
    // Corrective Actions
    "ca.title": "Corrective Actions", "ca.subtitle": "Manage non-conformities and improvement actions",
    "ca.new": "New Action",
    // Reports
    "rep.title": "Reports & Exports", "rep.subtitle": "Generate and export compliance reports",
    "rep.export_pdf": "Export PDF",
    // Calendar
    "cal.title": "Compliance Calendar", "cal.subtitle": "Track compliance events, deadlines and reviews",
    "cal.new": "New Event",
    // Mappings
    "map.title": "Framework Mappings", "map.subtitle": "Cross-framework control mappings",
    // Vendors
    "vend.title": "Vendor Risk", "vend.subtitle": "Assess and manage third-party vendor risk",
    "vend.new": "Add Vendor",
    // Training
    "train.title": "Training & Awareness", "train.subtitle": "Security training and awareness programs",
    "train.new": "New Training",
    // Heat Map
    "heat.title": "Risk Heat Map", "heat.subtitle": "Visualize risks by impact and likelihood",
    // Certification
    "cert.title": "Certification Readiness", "cert.subtitle": "Track readiness for ISO/NIST certification audits",
    // Benchmarking
    "bench.title": "Benchmarking", "bench.subtitle": "Compare your compliance posture against industry standards",
    // Policy Generator
    "pol.title": "Policy Generator", "pol.subtitle": "AI-powered policy and procedure drafting",
    // Threat Intel
    "ti.title": "Threat Intelligence", "ti.subtitle": "Latest threat feeds and indicators of compromise",
    // Vuln Scanner
    "vuln.title": "Vulnerability Scanner", "vuln.subtitle": "Discovered vulnerabilities from connected scanners",
    // Risk Predictor
    "pred.title": "AI Risk Intelligence", "pred.subtitle": "Predictive analytics on your risk register",
    // Wizard
    "wiz.title": "Implementation Wizard", "wiz.subtitle": "Step-by-step AI guidance for control implementation",
    // Maintenance
    "mnt.title": "Maintenance", "mnt.subtitle": "Scheduled compliance system maintenance and reviews",
    // Email settings
    "email.title": "Email Settings", "email.subtitle": "Configure SMTP for compliance notifications",
    // RBAC
    "rbac.title": "Access Control (RBAC)", "rbac.subtitle": "Manage user roles and permissions",
    // Bulk
    "bulk.title": "Bulk Import/Export", "bulk.subtitle": "Mass upload or download compliance data",
    // Client Portal
    "portal.title": "Client Portal", "portal.subtitle": "Generate secure read-only links for stakeholders",
    // Tenant
    "tenant.title": "Multi-Tenancy", "tenant.subtitle": "Manage client organizations and tenants",
    "tenant.new_org": "New Client Org", "tenant.managed": "Managed Organizations",
    "tenant.health": "Health Score", "tenant.switch": "Switch To", "tenant.domain": "Domain",
    // Evidence Collection
    "evcoll.title": "Auto Evidence Collection", "evcoll.subtitle": "Automated cloud service auditing",
    "evcoll.configure": "Configure", "evcoll.collect": "Collect",
    "evcoll.collecting": "Collecting...", "evcoll.last_run": "Last run", "evcoll.items_collected": "Items",
    // Notifications
    "notif.title": "Notifications", "notif.mark_all": "Mark all read",
    "notif.no_notifications": "No notifications", "notif.refresh": "Refresh",
    // Dashboard
    "dashboard.title": "Dashboard", "dashboard.subtitle": "Compliance overview and key metrics",
    "dashboard.overall": "Overall Compliance Score", "dashboard.health": "Compliance Health Score",
    "dashboard.trend": "Compliance Score Trend", "dashboard.trend_desc": "Framework compliance scores over the last 90 days",
    "dashboard.risk_dist": "Risk Distribution", "dashboard.recent_incidents": "Recent Incidents",
    "dashboard.fw_scores": "Framework Scores", "dashboard.welcome": "Welcome back",
    "dashboard.quick_stats": "Quick Stats",
    "dashboard.greeting_morning": "Good morning",
    "dashboard.greeting_afternoon": "Good afternoon",
    "dashboard.greeting_evening": "Good evening",
    "dashboard.greeting_fallback": "there",
    "dashboard.export_success": "Executive report downloaded",
    "dashboard.export_failed": "PDF export failed",
    "dashboard.grade_label": "Grade",
    "dashboard.active_frameworks": "Active frameworks:",
    // Controls
    "controls.title": "Control Library", "controls.subtitle": "Browse compliance controls across frameworks",
    "controls.search_placeholder": "Search controls...", "controls.framework": "Framework",
    "controls.category": "Category", "controls.total_controls": "Total Controls",
    // Risks
    "risks.title": "Risk Register", "risks.subtitle": "Manage assets, threats, vulnerabilities, and risks",
    "risks.assessments": "Risk Assessments (by Client)",
    "risks.new_assessment": "New Risk Assessment",
    "risks.add_asset": "Add Asset", "risks.add_risk": "Add Risk",
    "risks.matrix": "Risk Matrix", "risks.treatment": "Treatment", "risks.likelihood": "Likelihood",
    "risks.impact": "Impact", "risks.asset": "Asset", "risks.threat": "Threat",
    "risks.risk_category": "Risk Category", "risks.risk_source": "Risk Source",
    "risks.existing_controls": "Existing Controls",
    "risks.ph_asset_desc": "Brief description of the asset",
    "risks.ph_risk_desc": "Describe the risk scenario",
    "risks.ph_select_asset": "Select an asset", "risks.ph_select_threat": "Select a threat (optional)",
    "risks.ph_select_category": "Select category", "risks.ph_select_source": "Select source",
    "risks.ph_existing_controls": "Describe current controls in place...",
    "risks.add": "Add Risk", "risks.likelihood": "Likelihood", "risks.impact": "Impact",
    "risks.score": "Risk Score", "risks.level": "Risk Level", "risks.treatment": "Treatment",
    "risks.owner": "Risk Owner", "risks.category": "Risk Category", "risks.source": "Risk Source",
    "risks.residual": "Residual Risk", "risks.residual_score": "Residual Risk Score",
    "risks.cia": "CIA Impact Assessment (ISO 27005)", "risks.confidentiality": "Confidentiality",
    "risks.integrity": "Integrity", "risks.availability": "Availability",
    "risks.existing_controls": "Existing Controls", "risks.appetite": "Risk Appetite",
    "risks.review_freq": "Review Frequency", "risks.iso_assessment": "ISO 31000 / ISO 27005 Assessment",
    "risks.accept": "Accept", "risks.mitigate": "Mitigate", "risks.transfer": "Transfer", "risks.avoid": "Avoid",
    "risks.strategic": "Strategic", "risks.operational": "Operational", "risks.compliance": "Compliance",
    "risks.financial": "Financial", "risks.reputational": "Reputational", "risks.technological": "Technological",
    "risks.natural": "Natural",
    "risks.internal": "Internal", "risks.external": "External", "risks.environmental": "Environmental",
    "risks.monthly": "Monthly", "risks.quarterly": "Quarterly", "risks.semi_annual": "Semi-Annual", "risks.annual": "Annual",
    "risks.cat.strategic": "Strategic", "risks.cat.operational": "Operational", "risks.cat.compliance": "Compliance",
    "risks.cat.financial": "Financial", "risks.cat.reputational": "Reputational",
    "risks.cat.technological": "Technological", "risks.cat.natural": "Natural",
    "risks.source.internal": "Internal", "risks.source.external": "External",
    "risks.source.environmental": "Environmental",
    "risks.new_risk_title": "Add New Risk", "risks.new_risk_desc": "Create a new risk entry in your register",
    "risks.new_asset_title": "Add New Asset", "risks.new_asset_desc": "Add an asset to your inventory for risk assessment",
    "risks.asset_name": "Asset Name", "risks.asset_type": "Asset Type", "risks.asset_desc": "Description",
    "risks.asset_type.hardware": "Hardware", "risks.asset_type.software": "Software",
    "risks.asset_type.data": "Data", "risks.asset_type.service": "Service", "risks.asset_type.people": "People",
    "risks.confidentiality": "Confidentiality", "risks.integrity": "Integrity", "risks.availability": "Availability",
    "risks.title_label": "Risk Title", "risks.related_asset": "Related Asset", "risks.threat_label": "Threat",
    "risks.risk_score": "Risk Score", "risks.residual_likelihood": "Residual Likelihood",
    "risks.residual_impact": "Residual Impact", "risks.residual_risk_score": "Residual Risk Score",
    "risks.relevant_frameworks": "Relevant Frameworks",
    "risks.ph_appetite": "Select appetite", "risks.ph_frequency": "Select frequency",
    "risks.ph_risk_title": "e.g., Unauthorized access to customer data",
    "risks.ph_asset_name": "e.g., Production Database Server",
    "risks.save_changes": "Save Changes", "risks.add_btn": "Add Risk",
    "risks.add_asset_btn": "Add Asset",
    "risks.delete_confirm_title": "Delete Risk",
    "risks.delete_confirm_desc": "Are you sure you want to delete this risk? This action cannot be undone.",
    "risks.no_risks": "No risks registered yet",
    "risks.no_risks_desc": "Start tracking risks across your assets and frameworks.",
    "risks.no_risks_filter": "No risks match your filters",
    "risks.no_risks_filter_desc": "Try clearing the search or changing the level filter.",
    "risks.add_first": "Add your first risk",
    "risks.score_label": "Risk Score:",
    "risks.cia_section": "CIA Impact Assessment (ISO 27005)",
    "risks.load_from_catalog": "Load from Risk Catalog",
    "risks.catalog_placeholder": "Select from catalog (optional)",
    "risks.template_applied": "Template applied — editable",
    // SoA
    "soa.title": "Statement of Applicability", "soa.subtitle": "Manage control applicability and implementation status",
    "soa.generate": "Generate SoA",
    "soa.applicable": "Applicable", "soa.justification": "Justification",
    "soa.implementation": "Implementation Status",
    "soa.assessments": "SoA Projects (by Client)",
    "soa.new_assessment": "New SoA Project",
    // Documents
    "docs.title": "Document Management", "docs.subtitle": "Upload, version, and manage compliance documents",
    "docs.new": "New Document", "docs.upload": "Upload", "docs.version": "Version",
    "docs.published": "Published", "docs.draft": "Draft", "docs.archived": "Archived",
    // Evidence
    "evidence.title": "Evidence Management", "evidence.subtitle": "Collect and link evidence to controls",
    "evidence.new": "New Evidence", "evidence.linked_controls": "Linked Controls",
    "evidence.collection_method": "Collection Method", "evidence.period": "Period Covered",
    // Audits
    "audits.title": "Internal Audits", "audits.subtitle": "Plan, execute, and track internal audits",
    "audits.new": "New Audit", "audits.lead": "Lead Auditor", "audits.scope": "Scope",
    "audits.planned": "Planned", "audits.findings": "Findings",
    "audits.nc": "Non-Conformities", "audits.nc_new": "New Non-Conformity",
    // Incidents
    "incidents.title": "Incident Management", "incidents.subtitle": "Track and manage security incidents",
    "incidents.new": "New Incident", "incidents.severity": "Severity",
    "incidents.workflow": "Workflow Step", "incidents.reported_by": "Reported By",
    "incidents.investigating": "Investigating", "incidents.contained": "Contained",
    "incidents.resolved": "Resolved",
    // Management Review
    "review.title": "Management Review", "review.subtitle": "Schedule and conduct management reviews",
    "review.new": "New Review", "review.agenda": "Agenda", "review.decisions": "Decisions",
    "review.action_items": "Action Items", "review.scheduled": "Scheduled",
    // Corrective Actions
    "ca.title": "Corrective Actions", "ca.subtitle": "Track and manage corrective actions from audits, incidents, and reviews",
    "ca.new": "New Corrective Action", "ca.root_cause": "Root Cause",
    "ca.action_plan": "Action Plan", "ca.effectiveness": "Effectiveness Review",
    "ca.closure_rate": "Closure Rate",
    // Maintenance
    "maint.title": "Maintenance Calendar", "maint.subtitle": "Schedule and track recurring compliance tasks",
    "maint.new": "New Task", "maint.frequency": "Frequency", "maint.due_date": "Due Date",
    "maint.last_completed": "Last Completed", "maint.due_this_week": "Due This Week",
    "maint.complete": "Mark Complete",
    "maint.daily": "Daily", "maint.weekly": "Weekly", "maint.monthly": "Monthly",
    "maint.quarterly": "Quarterly", "maint.semi_annual": "Semi-Annual", "maint.annual": "Annual",
    "maint.policy_review": "Policy Review", "maint.control_update": "Control Update",
    "maint.cert_renewal": "Certificate Renewal", "maint.training": "Training",
    "maint.backup_verify": "Backup Verification", "maint.access_review": "Access Review",
    "maint.vuln_scan": "Vulnerability Scan", "maint.other": "Other",
    // Mappings
    "mappings.title": "Cross-Framework Mappings", "mappings.subtitle": "Control mappings across compliance frameworks",
    // Gap Analysis
    "gap.title": "Gap Analysis", "gap.subtitle": "Automated compliance gap assessment by framework",
    "gap.coverage": "Coverage", "gap.gaps_found": "gaps found", "gap.recommendations": "Recommendations",
    "gap.no_evidence": "No evidence linked", "gap.not_implemented": "Control not fully implemented",
    "gap.new_project": "New GAP Project", "gap.projects": "GAP Projects",
    "gap.no_projects": "No GAP projects yet. Click 'New GAP' to start your first assessment.",
    "gap.select_client": "Select Client Organization", "gap.client_required": "Create a client tenant first in Multi-Tenancy",
    "gap.project_name": "Project Name", "gap.contact_name": "Contact Name", "gap.contact_email": "Contact Email",
    "gap.responsible": "Responsible (Consultant)", "gap.framework_select": "Framework / Standard",
    "gap.notes": "Notes", "gap.run_assessment": "Run GAP Assessment", "gap.view_details": "View Details",
    "gap.mark_completed": "Mark as Completed", "gap.run_again": "Re-Run",
    "gap.last_run": "Last run", "gap.never_run": "Not yet executed",
    "gap.overview": "Global Overview", "gap.my_projects": "My GAP Projects",
    // Engagements
    "eng.status.in_progress": "In Progress", "eng.status.completed": "Completed",
    "eng.status.on_hold": "On Hold", "eng.status.cancelled": "Cancelled",
    // Certification
    "cert.title": "Certification Readiness", "cert.subtitle": "Assess if your organization is ready for external certification audit",
    "cert.score": "Readiness Score", "cert.blockers": "Certification Blockers",
    "cert.blockers_desc": "Issues that must be resolved before certification",
    "cert.no_blockers": "No blockers! You are ready for certification.",
    "cert.breakdown": "Score Breakdown", "cert.next_steps": "Next Steps",
    "cert.ready": "Ready for Certification Audit", "cert.almost": "Almost Ready - Minor Gaps",
    "cert.in_progress": "In Progress - Significant Work Needed", "cert.not_ready": "Not Ready - Major Implementation Required",
    // Reports
    "reports.title": "Reports & Exports", "reports.subtitle": "Executive summary and PDF report generation",
    "reports.export_pdf": "Export PDF", "reports.sections": "Report Sections",
    "reports.sections_desc": "Select what to include in the PDF",
    "reports.compliance_scores": "Compliance Scores", "reports.risk_summary": "Risk Summary",
    "reports.incident_summary": "Incident Summary", "reports.audit_summary": "Audit Summary",
    "reports.ca_summary": "Corrective Actions", "reports.doc_summary": "Document Summary",
    // Exec Report
    "exec.title": "Executive Report Generator", "exec.subtitle": "AI-powered board-ready compliance reports in business language",
    "exec.focus": "Report Focus", "exec.general": "General Overview", "exec.risk": "Risk Posture",
    "exec.compliance": "Compliance Status", "exec.incidents": "Incident Analysis",
    "exec.improvement": "Improvement Progress", "exec.board_report": "Board Report",
    // Benchmarking
    "bench.title": "Compliance Benchmarking", "bench.subtitle": "Compare your scores against industry averages",
    "bench.percentile": "Percentile Ranking", "bench.industry_avg": "Industry Average",
    "bench.median": "Median", "bench.top25": "Top 25%", "bench.top10": "Top 10%",
    "bench.gap_to_top": "to reach Top 25%", "bench.in_top": "You are in the Top 25%!",
    "bench.sector_comparison": "Your Score vs. Industry Sectors",
    "bench.sector_desc": "Green = you outperform, Red = sector outperforms you",
    "bench.distribution": "Score Distribution",
    // Policy Generator
    "policy.title": "Policy Generator", "policy.subtitle": "AI-powered policy and procedure document generation",
    "policy.generate_doc": "Generate Document", "policy.control": "Control",
    "policy.doc_type": "Document Type", "policy.policy": "Policy", "policy.procedure": "Procedure",
    "policy.guideline": "Guideline", "policy.checklist": "Checklist",
    "policy.generated": "Generated Document", "policy.select_generate": "Select a control and click Generate",
    "policy.ai_desc": "AI will create a complete, audit-ready document",
    // Vendor Risk
    "vendor.title": "Vendor Risk Management", "vendor.subtitle": "Assess and monitor third-party security risks (A.5.19-A.5.22)",
    "vendor.add": "Add Vendor", "vendor.assess": "Assess", "vendor.questionnaire": "Security Assessment",
    "vendor.questionnaire_desc": "Complete the security questionnaire to calculate vendor risk score",
    "vendor.submit_assessment": "Submit Assessment", "vendor.not_assessed": "Not assessed",
    "vendor.risk_score": "Risk Score", "vendor.contact": "Contact",
    "vendor.data_access": "Data Access Level", "vendor.criticality": "Criticality",
    "vendor.services": "Services Provided",
    "vendor.technology": "Technology", "vendor.cloud": "Cloud", "vendor.consulting": "Consulting",
    "vendor.outsourcing": "Outsourcing",
    "vendor.none": "None", "vendor.limited": "Limited", "vendor.significant": "Significant", "vendor.full": "Full",
    // Calendar
    "calendar.title": "Compliance Calendar", "calendar.subtitle": "Unified view of all compliance deadlines and events",
    "calendar.upcoming": "Upcoming", "calendar.today": "Today",
    "calendar.all_events": "All Events",
    "calendar.maintenance_type": "Maintenance", "calendar.ca_type": "Corrective Action",
    "calendar.audit_type": "Audit", "calendar.review_type": "Review", "calendar.risk_type": "Risk Review",
    // Threat Intel
    "threat.title": "Threat Intelligence", "threat.subtitle": "Monitor, analyze, and respond to security threats",
    "threat.new": "New Intel", "threat.dashboard": "Dashboard", "threat.registry": "Intel Registry",
    "threat.mitre": "MITRE ATT&CK", "threat.global_threats": "Global Threats",
    "threat.active": "Active", "threat.monitoring": "Monitoring", "threat.mitigated": "Mitigated",
    "threat.mitre_coverage": "MITRE ATT&CK Coverage",
    "threat.mitre_desc": "Mapped tactics and techniques from your threat intelligence",
    // Email Settings
    "email.title": "Email Settings", "email.subtitle": "Configure SMTP to enable email notifications",
    "email.smtp_config": "SMTP Server Configuration", "email.smtp_desc": "Connect to any SMTP provider to send notifications",
    "email.quick_setup": "Quick Setup - Select Provider", "email.host": "SMTP Host",
    "email.port": "Port", "email.username": "Username", "email.from_email": "From Email",
    "email.from_name": "From Name", "email.test_config": "Test Configuration",
    "email.test_desc": "Send a test email to verify your SMTP settings work",
    "email.send_test": "Send Test", "email.sending": "Sending...",
    "email.send_notif": "Send Notifications", "email.send_notif_desc": "Trigger email notifications manually",
    "email.overdue_tasks": "Overdue Tasks", "email.overdue_cas": "Overdue CAs",
    "email.compliance_alert": "Compliance Alert", "email.weekly_digest": "Weekly Digest",
    "email.send_all": "Send All", "email.verified": "SMTP Verified",
    "email.configured": "Configured", "email.not_configured": "Save SMTP configuration first",
    // RBAC
    "rbac.title": "Access Control & Audit Trail", "rbac.subtitle": "Manage user roles, permissions, and activity log",
    "rbac.users": "Organization Users", "rbac.users_desc": "Assign roles to control module access",
    "rbac.roles": "Role Definitions", "rbac.audit_trail": "Audit Trail", "rbac.recent": "Recent activity log",
    // Training
    "training.title": "Training & Awareness", "training.subtitle": "Manage security awareness programs (ISO 27001 A.6.3)",
    "training.new": "New Training", "training.programs": "Total Programs",
    "training.completions": "Completions", "training.completion_rate": "Completion Rate",
    "training.complete_btn": "Complete", "training.awareness": "Security Awareness",
    "training.phishing": "Phishing Prevention", "training.data_protection": "Data Protection",
    "training.incident_response": "Incident Response", "training.gdpr": "GDPR/Privacy",
    "training.access_control": "Access Control",
    // Risk Heat Map
    "heatmap.title": "Risk Heat Map", "heatmap.subtitle": "Interactive risk visualization across likelihood and impact",
    "heatmap.matrix": "Likelihood vs Impact Matrix", "heatmap.matrix_desc": "Click a cell to see risks at that position",
    "heatmap.by_level": "By Risk Level", "heatmap.by_treatment": "By Treatment", "heatmap.by_category": "By Category",
    // Vuln Scanner
    "vuln.title": "Vulnerability Scanner Import", "vuln.subtitle": "Import findings from vulnerability scanners into Threat Intelligence",
    "vuln.import": "Import Scan", "vuln.manual": "Manual Entry", "vuln.manual_title": "Manual Vulnerability Entry",
    "vuln.how_to": "How to Import", "vuln.findings": "Findings (JSON)",
    "vuln.import_findings": "Import Findings", "vuln.importing": "Importing...",
    // Risk Predictor
    "predictor.title": "AI Risk Intelligence", "predictor.subtitle": "Predictive analytics and What-If scenario simulations",
    "predictor.tab_predict": "Risk Predictor", "predictor.tab_scenarios": "What-If Scenarios",
    "predictor.analyze": "AI Risk Prediction", "predictor.analyze_desc": "Analyze historical data to predict future risks",
    "predictor.run": "Run Analysis", "predictor.analyzing": "Analyzing...",
    "predictor.custom": "Custom Scenario", "predictor.simulate": "Simulate",
    "predictor.simulating": "Running scenario simulation...",
    // Bulk
    "bulk.title": "Bulk Import / Export", "bulk.subtitle": "Import and export compliance data in bulk",
    "bulk.export_data": "Export Data", "bulk.export_desc": "Download module data as JSON or CSV",
    "bulk.import_data": "Import Data", "bulk.import_desc": "Import data from JSON",
    "bulk.module": "Module", "bulk.format": "Format", "bulk.json_data": "JSON Data",
    // Multi-Tenancy
    "tenant.title": "Multi-Tenant Management", "tenant.subtitle": "Manage multiple organizations from a single dashboard",
    "tenant.new_org": "New Organization", "tenant.managed": "Managed Organizations",
    "tenant.switch": "Switch to this org", "tenant.health": "Health Score",
    "tenant.domain": "Domain",
    // Client Portal
    "portal.title": "Client Portal", "portal.subtitle": "Share read-only compliance views with stakeholders",
    "portal.create_link": "Create Portal Link", "portal.label": "Label",
    "portal.modules": "Modules", "portal.expires": "Expires In",
    "portal.views": "Views", "portal.token": "Token", "portal.no_links": "No portal links created yet",
    // Evidence Collection
    "evcoll.title": "Automated Evidence Collection", "evcoll.subtitle": "Connect cloud platforms to automatically collect compliance evidence",
    "evcoll.configure": "Configure", "evcoll.collect": "Collect Evidence",
    "evcoll.collecting": "Collecting...", "evcoll.last_run": "Last run",
    "evcoll.items_collected": "Items collected",
    // Wizard
    "wizard.title": "Implementation Wizard", "wizard.subtitle": "AI-guided step-by-step implementation for each compliance framework",
    "wizard.start": "Start Implementation", "wizard.phases": "Implementation Phases",
    "wizard.ai_expert": "AI Implementation Expert", "wizard.select_phase": "Select a phase to start your AI-guided implementation",
    "wizard.deliverables": "Key Deliverables",
    // Incidents extra keys
    "incidents.total": "Total Incidents", "incidents.open": "Open Incidents", "incidents.critical_p1": "Critical (P1)",
    "incidents.resolved": "Resolved",
    "incidents.search_ph": "Search incidents...", "incidents.all_severities": "All Severities",
    "incidents.all_statuses": "All Statuses",
    "incidents.detected": "Detected", "incidents.source_label": "Source",
    "incidents.no_incidents_title": "No incidents to track",
    "incidents.no_incidents_desc": "Quiet skies for now. Report any security event so it stays auditable.",
    "incidents.report_one": "Report an incident",
    "incidents.new_sheet_title": "Report New Incident",
    "incidents.new_sheet_desc": "Create a new security incident record",
    "incidents.title_label": "Incident Title",
    "incidents.desc_label": "Description",
    "incidents.category_label": "Category",
    "incidents.detection_source_label": "Detection Source",
    "incidents.create_btn": "Create Incident",
    "incidents.detail_detected": "Detected",
    // Incident categories
    "inc.cat.data_breach": "Data Breach", "inc.cat.ransomware": "Ransomware",
    "inc.cat.phishing": "Phishing", "inc.cat.insider_threat": "Insider Threat",
    "inc.cat.ddos": "DDoS Attack", "inc.cat.unauthorized_access": "Unauthorized Access",
    "inc.cat.system_failure": "System Failure", "inc.cat.service_disruption": "Service Disruption",
    "inc.cat.physical_security": "Physical Security", "inc.cat.supply_chain": "Supply Chain",
    "inc.cat.other": "Other",
    // Incident severities
    "inc.sev.p1": "P1 - Critical", "inc.sev.p2": "P2 - High",
    "inc.sev.p3": "P3 - Medium", "inc.sev.p4": "P4 - Low",
    // Incident statuses
    "inc.status.new": "New", "inc.status.triaged": "Triaged",
    "inc.status.investigating": "Investigating", "inc.status.contained": "Contained",
    "inc.status.eradicated": "Eradicated", "inc.status.recovering": "Recovering",
    "inc.status.closed": "Closed",
    // Incident detection sources
    "inc.src.user_report": "User Report", "inc.src.siem_alert": "SIEM Alert",
    "inc.src.threat_intel": "Threat Intelligence", "inc.src.vulnerability_scan": "Vulnerability Scan",
    "inc.src.third_party": "Third Party", "inc.src.internal_audit": "Internal Audit",
    "inc.src.other": "Other",
    // Documents extra keys
    "docs.create_title": "Create New Document",
    "docs.create_desc": "Add a new policy, procedure, or compliance document",
    "docs.title_label": "Document Title",
    "docs.type_label": "Document Type",
    "docs.framework_label": "Framework",
    "docs.content_label": "Content",
    "docs.folder_label": "Folder",
    "docs.create_btn": "Create Document",
    "docs.search_ph": "Search documents...",
    "docs.all_statuses": "All Statuses",
    "docs.showing": "Showing {count} of {total} documents",
    "docs.no_docs_title": "No documents yet",
    "docs.no_docs_desc": "Policies, procedures, evidence — keep them all here, audit-ready.",
    "docs.create_first": "Create your first document",
    "docs.delete_title": "Delete Document",
    "docs.delete_desc": "Are you sure you want to delete this document? This action cannot be undone.",
    "docs.updated": "Updated",
    "docs.ph_content": "Document content...",
    "docs.ph_folder": "e.g., Policies, Procedures...",
    "docs.ph_title": "e.g., Information Security Policy",
    // Document types
    "docs.type.policy": "Policy", "docs.type.procedure": "Procedure",
    "docs.type.plan": "Plan", "docs.type.register": "Register",
    "docs.type.report": "Report", "docs.type.form": "Form",
    // Document statuses
    "docs.status.draft": "Draft", "docs.status.under_review": "Under Review",
    "docs.status.approved": "Approved", "docs.status.published": "Published",
    // Threat Intelligence extra keys
    "threat.new_intel": "New Threat Intelligence",
    "threat.new_intel_desc": "Record a new threat observation or intelligence report",
    "threat.name_label": "Name",
    "threat.category_label": "Category",
    "threat.severity_label": "Severity",
    "threat.source_label": "Source",
    "threat.description_label": "Description",
    "threat.iocs_label": "IOCs (Indicators of Compromise)",
    "threat.iocs_ph": "IP, hash, domain...",
    "threat.mitre_label": "MITRE ATT&CK Techniques",
    "threat.frameworks_label": "Relevant Frameworks",
    "threat.create_btn": "Create Intel",
    "threat.search_ph": "Search threat intel...",
    "threat.all_severity": "All Severity",
    "threat.all_categories": "All Categories",
    "threat.all_frameworks": "All Frameworks",
    "threat.total_intel": "Total Intel",
    "threat.active_threats": "Active Threats",
    "threat.tab_dashboard": "Dashboard", "threat.tab_registry": "Intel Registry",
    "threat.tab_mitre": "MITRE ATT&CK", "threat.tab_threats": "Global Threats",
    "threat.by_severity": "By Severity", "threat.by_category": "By Category",
    "threat.no_data": "No data yet",
    "threat.no_intel": "No threat intel yet", "threat.no_results": "No results match filters",
    "threat.status_label": "Status",
    "threat.source_label_detail": "Source", "threat.iocs_detail": "IOCs",
    "threat.mitre_detail": "MITRE ATT&CK", "threat.created": "Created",
    "threat.known_threats": "Known Threats", "threat.known_vulns": "Known Vulnerabilities",
    // Threat categories (UI)
    "threat.cat.malware": "Malware", "threat.cat.social_engineering": "Social Engineering",
    "threat.cat.network": "Network", "threat.cat.human": "Human",
    "threat.cat.data": "Data", "threat.cat.third_party": "Third Party",
    "threat.cat.vulnerability": "Vulnerability", "threat.cat.apt": "APT",
    // Threat sources
    "threat.src.internal": "Internal", "threat.src.osint": "OSINT",
    "threat.src.vendor": "Vendor", "threat.src.government": "Government",
    "threat.src.industry": "Industry",
    // Evidence extra keys
    "evid.total": "Total Evidence", "evid.pending_review": "Pending Review",
    "evid.approved": "Approved", "evid.linked_controls": "Linked to Controls",
    "evid.search_ph": "Search evidence...",
    "evid.all_types": "All Types", "evid.all_statuses": "All Statuses",
    "evid.add_sheet_title": "Add Evidence",
    "evid.add_sheet_desc": "Create a new evidence record for compliance controls",
    "evid.title_label": "Title", "evid.type_label": "Evidence Type",
    "evid.period_label": "Period Covered", "evid.framework_label": "Framework",
    "evid.link_controls": "Link to Controls", "evid.control_search": "Search controls...",
    "evid.desc_label": "Description", "evid.create_btn": "Create Evidence",
    "evid.no_evidence_title": "No evidence collected yet",
    "evid.no_evidence_desc": "Attach screenshots, configs, logs and reports — auditors will love you.",
    "evid.add_first": "Add your first evidence",
    "evid.file_attached": "File attached",
    "evid.linked_count": "linked controls",
    "evid.period_label_detail": "Period",
    "evid.added": "Added",
    "evid.delete_title": "Delete Evidence",
    "evid.delete_desc": "Are you sure you want to delete this evidence? This action cannot be undone.",
    "evid.update_status": "Update status",
    "evid.ph_title": "e.g., Access Control Policy Screenshot",
    "evid.ph_period": "e.g., Q1 2024, Jan-Mar 2024",
    // Evidence types
    "evid.type.screenshot": "Screenshot", "evid.type.document": "Document",
    "evid.type.log": "Log Export", "evid.type.config": "Configuration",
    "evid.type.certificate": "Certificate", "evid.type.contract": "Contract",
    "evid.type.interview": "Interview Record", "evid.type.incident": "Incident Record",
    "evid.type.threat_report": "Threat Report",
    // Evidence review statuses
    "evid.status.pending": "Pending Review", "evid.status.reviewed": "Reviewed",
    "evid.status.approved": "Approved", "evid.status.rejected": "Rejected",
    // EvidenceCollection (auto-cloud) keys
    "ec.page_desc": "Connect AWS, Azure, GCP, GitHub or Okta to scan security configurations and collect evidence mapped to ISO 27001.",
    "ec.load_failed": "Failed to load data",
    "ec.field_required": "is required",
    "ec.creds_saved": "Credentials saved",
    "ec.save_failed": "Save failed",
    "ec.validation_failed": "Validation failed",
    "ec.delete_confirm": "Delete credentials?",
    "ec.delete_title": "Delete credentials",
    "ec.deleted": "Deleted",
    "ec.delete_failed": "Delete failed",
    "ec.scan_failed": "Scan failed",
    "ec.detail_failed": "Failed to load detail",
    "ec.page_title": "Automated Cloud Auditing",
    "ec.providers_label": "Providers",
    "ec.connected_label": "Connected",
    "ec.scans_label": "Scans executed",
    "ec.findings_label": "Failed findings",
    "ec.tab_connectors": "Connectors",
    "ec.tab_history": "Scan history",
    "ec.badge_connected": "CONNECTED",
    "ec.badge_live": "Live scan",
    "ec.evidence_types": "Evidence types",
    "ec.last_scan": "Last scan",
    "ec.btn_edit": "Edit",
    "ec.btn_connect": "Connect",
    "ec.btn_scanning": "Scanning…",
    "ec.btn_scan": "Scan",
    "ec.no_scans": "No scans yet. Run one from the Connectors tab.",
    "ec.total_label": "Total",
    "ec.badge_saved": "Saved",
    "ec.placeholder_set": "•••• (saved)",
    "ec.provider_docs": "Provider docs",
    "ec.btn_delete": "Delete",
    "ec.btn_test": "Test",
    "ec.btn_save": "Save",
    "ec.scan_results": "Scan results",
    "ec.compliant": "Compliant",
    "ec.non_compliant": "Non-compliant",
    "ec.warnings": "Warnings",
    "ec.remediation": "Remediation:",
    "ec.aws_ok": "AWS OK — Account",
    "ec.creds_desc": "Credentials are stored per-organization. Only the owner can edit them.",
    "ec.owner_only": "Only the owner can save credentials.",
    // Audits extra keys
    "audits.frameworks_label": "Frameworks",
    "audits.scope_label": "Scope Description",
    "audits.lead_label": "Lead Auditor",
    "audits.start_date": "Start Date", "audits.end_date": "End Date",
    "audits.create_btn": "Create Audit",
    "audits.search_ph": "Search audits...",
    "audits.no_audits_title": "No audits yet",
    "audits.no_audits_desc": "Plan and track your internal compliance audits.",
    "audits.tab_audits": "Audits", "audits.tab_nc": "Non-Conformities",
    "audits.summary_title": "Audit Summary",
    "audits.generate_checklist": "Generate AI Checklist",
    "audits.generating": "Generating...",
    "audits.nc_title": "Non-Conformities",
    "audits.nc_type_label": "Type", "audits.nc_desc_label": "Description",
    "audits.nc_root_cause": "Root Cause", "audits.nc_corrective": "Corrective Action",
    "audits.nc_assigned_to": "Assigned To", "audits.nc_due_date": "Due Date",
    "audits.nc_create_btn": "Add Non-Conformity",
    "audits.status.planned": "Planned", "audits.status.in_progress": "In Progress",
    "audits.status.completed": "Completed", "audits.status.cancelled": "Cancelled",
    "audits.nc.minor": "Minor NC", "audits.nc.major": "Major NC",
    "audits.nc.opportunity": "Opportunity for Improvement",
    "audits.checklist.not_assessed": "Not Assessed", "audits.checklist.compliant": "Compliant",
    "audits.checklist.non_compliant": "Non-Compliant", "audits.checklist.observation": "Observation",
    "audits.checklist.not_applicable": "Not Applicable",
    "audits.new_title": "New Internal Audit", "audits.new_desc": "Schedule a new compliance audit",
    "audits.delete_title": "Delete Audit", "audits.delete_desc": "This will permanently delete the audit and all its findings.",
    // S16a-2: i18n sweep — legacy strings now via t()
    "audits.delete_confirm": "Delete this audit? This action cannot be undone.",
    "audits.toast.title_required": "Please enter an audit title",
    "audits.toast.created": "Audit program created",
    "audits.toast.create_failed": "Failed to create audit",
    "audits.toast.checklist_failed": "Failed to generate checklist",
    "audits.toast.status_updated": "Status updated to {status}",
    "audits.toast.status_failed": "Failed to update status",
    "audits.toast.item_failed": "Failed to update checklist item",
    "audits.toast.desc_required": "Please enter a description",
    "audits.toast.nc_created": "Non-conformity created",
    "audits.toast.nc_failed": "Failed to create non-conformity",
    "audits.toast.plan_saved": "Audit plan saved",
    "audits.toast.plan_failed": "Failed to save audit plan",
    "audits.toast.execution_started": "Audit execution started",
    "audits.toast.execution_failed": "Failed to start execution",
    "audits.toast.finding_created": "Finding recorded",
    "audits.toast.finding_failed": "Failed to record finding",
    "audits.toast.finalized": "Audit finalized",
    "audits.toast.finalize_failed": "Failed to finalize audit",
    "audits.toast.closed": "Audit formally closed",
    "audits.toast.close_failed": "Failed to close audit",
    "audits.log_nc_btn": "Log NC",
    "audits.checklist_count": "{count} checklist items",
    "audits.nc_assigned": "Assigned: {name}",
    "audits.nc_due": "Due: {date}",
    "audits.no_ncs_title": "No non-conformities",
    "audits.no_ncs_desc": "Clean slate. NCs raised during audits will appear here.",
    "audits.lead_inline": "Lead: {name}",
    "audits.change_status": "Change Status",
    "audits.add_nc_inline": "Add NC",
    "audits.summary": "Audit Summary",
    "audits.summary.compliant": "Compliant",
    "audits.summary.non_compliant": "Non-Compliant",
    "audits.summary.observation": "Observation",
    "audits.summary.na": "N/A",
    "audits.summary.compliance_rate": "Compliance",
    "audits.checklist_header": "Audit Checklist ({count} items)",
    "audits.nc.log_title": "Log Non-Conformity",
    "audits.nc.log_desc": "Record a non-conformity or opportunity for improvement",
    "audits.nc.type": "NC Type",
    "audits.nc.desc": "Description",
    "audits.nc.root_cause": "Root Cause",
    "audits.nc.action": "Corrective Action",
    "audits.nc.assigned": "Assigned To",
    "audits.nc.due": "Due Date",
    "audits.nc.desc_ph": "Describe the non-conformity...",
    "audits.nc.cause_ph": "What caused this issue?",
    "audits.nc.action_ph": "What needs to be done to fix this?",
    "audits.nc.create_btn": "Create NC",
    "audits.title_ph": "e.g., Q1 2024 ISO 27001 Internal Audit",
    "audits.lead_ph": "e.g., John Smith",
    // S16a-2: ISO 19011 phase labels
    "audits.phase.initiation": "Initiation",
    "audits.phase.preparation": "Preparation",
    "audits.phase.execution": "Execution",
    "audits.phase.reporting": "Reporting",
    "audits.phase.followup": "Follow-up",
    "audits.phase.closed": "Closed",
    // S16a-2: tab labels
    "audits.tab.plan": "Plan",
    "audits.tab.checklist": "Checklist",
    "audits.tab.findings": "Findings",
    "audits.tab.report": "Report",
    "audits.tab.followup": "Follow-up",
    // S16a-2: plan tab
    "audits.plan.objectives_label": "Audit Objectives",
    "audits.plan.criteria_label": "Audit Criteria",
    "audits.plan.competence_label": "Auditor Competence",
    "audits.plan.plan_label": "Audit Plan",
    "audits.plan.opening_notes": "Opening Meeting Notes",
    "audits.plan.objectives_ph": "What this audit aims to demonstrate...",
    "audits.plan.criteria_ph": "Standards, policies, regulations to evaluate against...",
    "audits.plan.competence_ph": "Auditor qualifications and relevant experience...",
    "audits.plan.plan_ph": "Audit schedule, activities, assignments...",
    "audits.plan.opening_notes_ph": "Minutes from opening meeting...",
    "audits.plan.save_btn": "Save Plan",
    "audits.plan.no_objectives": "No objectives defined",
    "audits.plan.no_plan": "No audit plan defined",
    "audits.plan.no_criteria": "No criteria defined",
    "audits.plan.scope_label": "Scope",
    "audits.plan.frameworks_label": "Frameworks",
    "audits.plan.lead_label": "Lead Auditor",
    "audits.plan.team_label": "Team",
    "audits.plan.start_execution_btn": "Start Execution",
    "audits.plan.finalize_btn": "Finalize Audit",
    "audits.plan.close_btn": "Close Audit",
    "audits.plan.closure_statement_label": "Closure Statement",
    "audits.plan.closure_statement_ph": "Summary statement confirming audit completion...",
    // S16a-2: checklist tab
    "audits.checklist.show_context": "Show Context",
    "audits.checklist.hide_context": "Hide Context",
    "audits.checklist.guidance_label": "Implementation Guidance",
    "audits.checklist.evidence_required_label": "Evidence Requirements",
    "audits.checklist.no_context": "No context available — regenerate checklist",
    "audits.checklist.regenerate_btn": "Regenerate Checklist",
    "audits.checklist.locale_badge": "Language",
    "audits.checklist.add_finding_btn": "Record Finding",
    "audits.checklist.filter_all": "All Results",
    "audits.checklist.filter_framework": "All Frameworks",
    "audits.checklist.search_ph": "Search controls...",
    // S16a-2: findings tab
    "audits.findings.add": "Record Finding",
    "audits.findings.none": "No findings recorded yet",
    "audits.findings.none_desc": "Record findings from the checklist as you evaluate controls.",
    "audits.findings.control": "Control",
    "audits.findings.type": "Type",
    "audits.findings.severity": "Severity",
    "audits.findings.description": "Description",
    "audits.findings.evidence": "Evidence Sources",
    "audits.findings.type.conformity": "Conformity",
    "audits.findings.type.nonconformity": "Non-Conformity",
    "audits.findings.type.opportunity": "Opportunity",
    "audits.findings.type.observation": "Observation",
    "audits.findings.severity_minor": "Minor",
    "audits.findings.severity_major": "Major",
    "audits.findings.log_title": "Record Audit Finding",
    "audits.findings.log_desc": "Document what was observed for this control",
    "audits.findings.type_label": "Finding Type",
    "audits.findings.desc_ph": "Describe what was observed...",
    "audits.findings.nc_linked": "Linked NC",
    // S16a-2: report tab
    "audits.report.generate_docx": "Generate Report (.docx)",
    "audits.report.generate_pdf": "Generate Report (.pdf)",
    "audits.report.distribute": "Distribute Report",
    "audits.report.not_available": "Report generation available in S16a-3",
    // S16a-2: close/followup
    "audits.close.statement_label": "Closure Statement",
    "audits.close.closed_at": "Closed At",
    "audits.close.closed_by": "Closed By",
    "audits.followup.next_review": "Next Review Date",
    "audits.followup.effectiveness": "Effectiveness Review",
    "audits.followup.none": "No follow-up actions yet",
    // C13: new action modal + inline-edit keys
    "audits.followup.new": "New Action",
    "audits.followup.created": "Action created",
    "audits.followup.create_failed": "Failed to create action",
    "audits.followup.updated": "Action updated",
    "audits.followup.update_failed": "Failed to update action",
    "audits.followup.no_nonconformities": "No non-conformities — actions cannot be created without one",
    "audits.followup.save": "Save",
    "audits.followup.cancel": "Cancel",
    "audits.followup.fields.description": "Description",
    "audits.followup.fields.responsible": "Responsible",
    "audits.followup.fields.due_date": "Due Date",
    "audits.followup.fields.status": "Status",
    "audits.followup.fields.notes": "Notes",
    "audits.followup.fields.non_conformity": "Non-conformity",
    "audits.followup.fields.non_conformity_placeholder": "Select related NC",
    "audits.followup.nc_required": "A non-conformity must be selected",
    "audits.followup.errors.description_required": "Description is required",
    "audits.followup.status.pending": "Pending",
    "audits.followup.status.in_progress": "In Progress",
    "audits.followup.status.verified": "Verified",
    "audits.followup.status.closed": "Closed",
    "audits.back_to_audits": "Back to Audits",
    "audits.open_detail": "Open Detail",
    // Corrective Actions extra keys
    "ca.search_ph": "Search corrective actions...", "ca.all_statuses": "All Statuses",
    "ca.all_priorities": "All Priorities",
    "ca.open": "Open", "ca.overdue": "Overdue", "ca.total": "Total",
    "ca.source_label": "Source", "ca.desc_label": "Description",
    "ca.priority_label": "Priority", "ca.owner_label": "Owner",
    "ca.due_date_label": "Due Date", "ca.create_btn": "Create Action",
    "ca.no_actions_title": "No corrective actions yet",
    "ca.no_actions_desc": "Corrective actions track non-conformities and improvements.",
    "ca.source.audit": "Audit", "ca.source.risk_review": "Risk Review",
    "ca.source.incident": "Incident", "ca.source.management_review": "Management Review",
    "ca.source.other": "Other",
    "ca.new_title": "New Corrective Action", "ca.new_desc": "Create a new corrective action",
    "ca.status.open": "Open", "ca.status.in_progress": "In Progress",
    "ca.status.closed": "Closed", "ca.status.overdue": "Overdue",
    "ca.toast.desc_required": "Description is required",
    "ca.toast.created": "Corrective action created",
    "ca.toast.create_failed": "Failed to create corrective action",
    "ca.toast.status_updated": "Status updated",
    "ca.toast.status_failed": "Failed to update status",
    "ca.toast.effectiveness_saved": "Effectiveness review saved",
    "ca.toast.effectiveness_failed": "Failed to save effectiveness review",
    // Vendor Risk extra keys
    "vendor.search_ph": "Search vendors...",
    "vendor.name_label": "Vendor Name", "vendor.category_label": "Category",
    "vendor.contact_name_label": "Contact Name", "vendor.contact_email_label": "Contact Email",
    "vendor.services_label": "Services Provided",
    "vendor.data_access_label": "Data Access Level",
    "vendor.criticality_label": "Criticality",
    "vendor.create_btn": "Add Vendor",
    "vendor.no_vendors_title": "No vendors added yet",
    "vendor.no_vendors_desc": "Track third-party vendors and their risk scores.",
    "vendor.new_title": "Add Vendor", "vendor.new_desc": "Register a new third-party vendor",
    "vendor.risk_summary": "Risk Summary",
    "vendor.cat.technology": "Technology", "vendor.cat.cloud": "Cloud",
    "vendor.cat.consulting": "Consulting", "vendor.cat.outsourcing": "Outsourcing",
    "vendor.access.none": "None", "vendor.access.limited": "Limited",
    "vendor.access.significant": "Significant", "vendor.access.full": "Full",
    // Management Review extra keys
    "review.create_title": "Schedule Management Review",
    "review.create_desc": "Plan a new management review meeting",
    "review.title_label": "Review Title",
    "review.date_label": "Review Date",
    "review.attendees_label": "Attendees",
    "review.attendee_ph": "Add attendee email",
    "review.agenda_label": "Agenda Items",
    "review.notes_label": "Notes",
    "review.create_btn": "Schedule Review",
    "review.no_reviews_title": "No reviews scheduled",
    "review.no_reviews_desc": "Management reviews are required by ISO 27001 clause 9.3.",
    "review.schedule_first": "Schedule your first review",
    "review.status.scheduled": "Scheduled", "review.status.in_progress": "In Progress",
    "review.status.completed": "Completed",
    "review.decisions_title": "Decisions", "review.add_decision": "Add Decision",
    "review.action_items_title": "Action Items", "review.add_action": "Add Action Item",
    "review.action_desc": "Description", "review.action_owner": "Owner",
    "review.action_due": "Due Date", "review.action_btn": "Add",
    // Training extra keys
    "training.cat.awareness": "Security Awareness", "training.cat.phishing": "Phishing Prevention",
    "training.cat.data_protection": "Data Protection", "training.cat.incident_response": "Incident Response",
    "training.cat.gdpr": "GDPR/Privacy", "training.cat.access_control": "Access Control",
    "training.cat.other": "Other",
    "training.no_programs": "No training programs yet",
    "training.new_program_title": "New Training Program",
    "training.desc_ph": "Brief description...",
    "training.roles": "Roles",
    // Maintenance extra keys
    "maint.total_tasks": "Total Tasks", "maint.all_status": "All Status",
    "maint.all_categories": "All Categories", "maint.search_tasks": "Search tasks...",
    "maint.loading": "Loading maintenance tasks...",
    "maint.next_due": "Next due", "maint.next_due_date": "Next Due Date",
    "maint.task_title": "Task Title", "maint.task_details_ph": "Task details...",
    "maint.assigned_to_ph": "Assigned to...", "maint.new_desc": "Schedule a recurring compliance task",
    "maint.create_task": "Create Task",
    "maint.title_date_required": "Title and due date are required",
    "maint.task_created": "Maintenance task created",
    "maint.create_failed": "Failed to create task",
    "maint.complete_failed": "Failed to complete task",
    "maint.status_update_failed": "Failed to update status",
    "maint.task_deleted": "Task deleted",
    "maint.delete_failed": "Failed to delete task",
    "maint.no_tasks": "No maintenance tasks scheduled",
    "maint.no_tasks_filter": "No tasks match your filters",
    "maint.schedule_first": "Schedule First Task",
    "maint.resume": "Resume", "maint.pause": "Pause",
    // Gap Analysis extra keys
    "gap.client_project_fw_required": "Client, project and framework are required",
    "gap.project_created_running": "GAP project created. Running assessment...",
    "gap.assessment_completed": "Assessment completed",
    "gap.project_marked_completed": "Project marked completed",
    "gap.delete_confirm": "Delete this GAP project?",
    "gap.delete_title": "Delete GAP project",
    "gap.deleted": "Deleted",
    "gap.finding_saved": "Finding saved",
    "gap.finding_save_failed": "Could not save finding",
    "gap.discard_confirm": "Discard your edits and revert to automatic calculation?",
    "gap.discard_title": "Discard edits",
    "gap.finding_reverted": "Edit reverted",
    "gap.revert_failed": "Error reverting",
    "gap.edit_finding": "Edit finding",
    "gap.owner_ph": "Name or role",
    "gap.target_date": "Target Date",
    "gap.notes_comments": "Notes / Comments",
    "gap.notes_ph": "Auditor observations or current status...",
    "gap.remediation_plan": "Remediation Plan",
    "gap.remediation_ph": "Actions, milestones and deliverables to close the gap...",
    "gap.linked_evidence": "Linked Evidence",
    "gap.no_evidence_repo": "No evidence in the repository. Upload them in the Evidence module.",
    "gap.linked_documents": "Linked Documents",
    "gap.no_docs_published": "No published documents.",
    "gap.revert": "Revert",
    "gap.saving": "Saving...",
    "gap.save_finding": "Save finding",
    "gap.findings": "Findings",
    "gap.due_label": "Due",
    "gap.evidences": "evidences",
    "gap.documents": "documents",
    // Policy Generator extra keys
    "pol.tab_templates": "Pre-Built Templates", "pol.tab_ai": "AI Generator",
    "pol.template_library_title": "Auditor-Ready Template Library",
    "pol.template_library_desc": "Pre-built templates per framework: policies, procedures, forms and job descriptions. Fill in your organization context, approver and reviewer, and the document will be saved in the Documents module ready to sign.",
    "pol.all_frameworks": "All Frameworks", "pol.all_types": "All Types",
    "pol.templates_available": "templates available",
    "pol.no_templates": "No templates match these filters.",
    "pol.use_template": "Use Template",
    "pol.generate_ai_title": "Generate with AI from a Control",
    "pol.control_label": "Control", "pol.choose_control": "Choose a control",
    "pol.generate_with_ai": "Generate with AI",
    "pol.edit_mode": "EDIT MODE",
    "pol.edit_before_save": "Edit the content before saving",
    "pol.discard": "Discard", "pol.saving": "Saving...",
    "pol.save_to_docs": "Save to Documents",
    "pol.chars_hint": "chars · Changes will persist when you click \"Save to Documents\"",
    "pol.discard_confirm": "Discard changes and close?",
    "pol.discard_title": "Discard changes",
    "pol.saved_to_docs": "Saved to Documents",
    "pol.view": "View",
    "pol.doc_generated": "Document generated. Edit and save when ready.",
    "pol.generate_error_fallback": "Generation failed. Please try again.",
    "pol.approver_reviewer_required": "Approver and reviewer are required",
    "pol.fill_dialog_desc": "Fill in the organization context. The document will be saved as 'draft' in Documents, ready for review and signature.",
    "pol.org_name_label": "Organization Name", "pol.address_label": "Address",
    "pol.version_label": "Version", "pol.classification_label": "Classification",
    "pol.effective_date_label": "Effective Date", "pol.next_review_label": "Next Review Date",
    "pol.approver_signer": "Approver (Signer)", "pol.role_label": "Role",
    "pol.reviewer": "Reviewer",
    "pol.extra_context_label": "Additional Context (optional)",
    "pol.extra_context_ph": "Organization-specific info to append to the document...",
    "pol.generate_and_save": "Generate & Save",
    "pol.export_failed": "Failed to export document. Please try again.",
    // Policy Generator doc types
    "pol.doctype.policy": "Policy", "pol.doctype.procedure": "Procedure",
    "pol.doctype.form": "Form", "pol.doctype.job_description": "Job Description",
    "pol.doctype.guideline": "Guideline", "pol.doctype.checklist": "Checklist",
    // Reports extra keys
    "rep.loading": "Loading report data...",
    "rep.generating": "Generating...",
    "rep.export_success": "Report exported successfully",
    "rep.export_failed": "Failed to export PDF",
    "rep.download_pdf": "Download PDF Report",
    "rep.compliance_overview": "Compliance Overview",
    "rep.compliance_overview_desc": "Current compliance posture across all frameworks",
    "rep.overall_score": "Overall Score", "rep.health_score": "Health Score",
    "rep.generated_at": "Report generated at",
    // Executive Report extra keys
    "exec.general_desc": "Comprehensive executive summary",
    "exec.risk_desc": "Focus on risks and treatment progress",
    "exec.compliance_desc": "Scores, gaps, certification readiness",
    "exec.incidents_desc": "Incident trends and response",
    "exec.improvement_desc": "CAs, KPIs, continuous improvement",
    "exec.report_generated": "Executive report generated",
    "exec.generation_failed": "Generation failed",
    "exec.generate_report": "Generate Report",
    "exec.compliance_label": "Compliance",
    "exec.health_label": "Health",
    "exec.critical_risks": "Critical Risks",
    "exec.preparing": "AI is preparing your board report...",
    "exec.select_focus": "Select a focus area and generate",
    "exec.ai_translates": "AI translates compliance metrics to executive language",
    // Benchmarking extra keys
    "bench.your_score": "Your Score",
    // Wizard extra keys
    "wizard.phase": "Phase", "wizard.phases_label": "phases",
    "wizard.controls_label": "controls",
    "wizard.loading": "Loading wizard...",
    "wizard.implementation": "Implementation",
    "wizard.ai_guide_desc": "The AI expert will guide you through each step with practical advice, templates, and evidence suggestions",
    "wizard.analyzing": "Analyzing...",
    "wizard.ask_about_phase": "Ask about Phase",
    "wizard.select_phase_left": "Select a phase from the left to begin",
    "wizard.start_phase": "Start", "wizard.complete_phase": "Complete",
    "wizard.marked_as": "marked as",
    "wizard.status_update_failed": "Failed to update status",
    // Engagements extra keys
    "eng.client_project_required": "Client and project are required",
    "eng.project_created_running": "Project created. Running snapshot...",
    "eng.snapshot_updated": "Snapshot updated",
    "eng.delete_confirm": "Delete this project?",
    "eng.delete_title": "Delete project",
    "eng.deleted": "Deleted",
    "eng.switch_confirm_prefix": "Work inside",
    "eng.switch_confirm_suffix": "tenant? Page will reload.",
    "eng.switch_title": "Switch tenant",
    "eng.context_switched": "Context switched. Reloading...",
    "eng.no_snapshot": "No snapshot",
    "eng.risks_label": "Risks", "eng.treated_label": "Treated",
    "eng.entries_label": "Entries",
    "eng.projects_label": "project(s)",
    "eng.current_badge": "CURRENT",
    "eng.open": "Open",
    "eng.your_org": "Your org",
    "eng.create_project_desc": "Create a project tied to a client tenant. All data is stored in the client's tenant.",
    // Common missing
    "name": "Name",
    "owner": "Owner",
    // S14a — Forgot/Reset password
    "auth.forgot.title": "Reset password",
    "auth.forgot.email_label": "Email",
    "auth.forgot.submit": "Send link",
    "auth.forgot.generic_response": "If the email exists, you'll receive a link shortly.",
    "auth.forgot.link_in_login": "Forgot password?",
    "auth.forgot.back_to_login": "Back to sign in",
    "auth.reset.title": "Choose a new password",
    "auth.reset.new_password": "New password",
    "auth.reset.confirm_password": "Confirm password",
    "auth.reset.submit": "Save",
    "auth.reset.invalid_token": "Invalid or expired link",
    "auth.reset.invalid_token_desc": "Request a new link to reset your password.",
    "auth.reset.success": "Password updated. Sign in.",
    "auth.reset.passwords_no_match": "Passwords do not match",
    "auth.reset.request_new": "Request new link",
    // B12 S16b-2 — 2FA lockout notice after successful password reset
    "auth.reset.2fa_banner.title": "About 2FA",
    "auth.reset.2fa_banner.body": "If you have 2FA enabled and lost your device, contact support so an administrator can disable 2FA after verifying your identity.",
    "auth.reset.success_heading": "Password updated",
    "auth.reset.success_desc": "Your password has been updated. You can now sign in.",
    "auth.reset.go_to_signin": "Sign in",
    // S14a — Platform Admin org/user CRUD
    "platform_admin.orgs.create": "New tenant",
    "platform_admin.orgs.suspend": "Suspend",
    "platform_admin.orgs.reactivate": "Reactivate",
    "platform_admin.orgs.delete": "Delete (soft)",
    "platform_admin.orgs.restore": "Restore",
    "platform_admin.orgs.delete_confirm": "To confirm, type the tenant name: {name}",
    "platform_admin.orgs.delete_warning": "This action is reversible for 30 days. Data is retained but access is blocked.",
    "platform_admin.orgs.restore_confirm": "Restore this organization and reactivate access?",
    "platform_admin.users.reset_pwd": "Reset password",
    "platform_admin.users.reset_sent": "Link sent to {email}",
    "platform_admin.users.reset_confirm": "Send a reset link to {email}? The admin will not see the new password.",
    // S14a — Audit log
    "platform_admin.audit.title": "Audit log",
    "platform_admin.audit.export_csv": "Export CSV",
    "platform_admin.audit.filter_action": "Action",
    "platform_admin.audit.filter_actor": "Actor",
    "platform_admin.audit.filter_target": "Target",
    "platform_admin.audit.filter_from": "From",
    "platform_admin.audit.filter_to": "To",
    "platform_admin.audit.open_full": "Open full page",
    "platform_admin.audit.recent_activity": "Recent activity",
    // S14b — 2FA TOTP
    "auth.2fa.setup.title": "Two-Factor Authentication",
    "auth.2fa.setup.intro_title": "Secure your account",
    "auth.2fa.setup.intro_desc": "Two-factor authentication adds an extra layer of security.",
    "auth.2fa.setup.step1": "Scan the QR code with Google Authenticator (or any TOTP app).",
    "auth.2fa.setup.step2": "Enter the 6-digit code shown by the app",
    "auth.2fa.setup.step3": "Save these recovery codes. Each one works only once.",
    "auth.2fa.setup.step_label_1": "Scan",
    "auth.2fa.setup.step_label_2": "Verify",
    "auth.2fa.setup.step_label_3": "Recovery",
    "auth.2fa.setup.scan_title": "Scan QR code",
    "auth.2fa.setup.manual_secret": "Cannot scan? Enter this code manually:",
    "auth.2fa.setup.verify_button": "Verify code",
    "auth.2fa.setup.recovery_title": "Save recovery codes",
    "auth.2fa.setup.download_codes": "Download codes (TXT)",
    "auth.2fa.setup.codes_copied": "Codes copied to clipboard",
    "auth.2fa.setup.confirm_saved": "I have saved my recovery codes in a secure location",
    "auth.2fa.setup.finish": "Finish",
    "auth.2fa.setup.finish_success": "Two-factor authentication is active.",
    "auth.2fa.setup.begin": "Begin setup",
    "auth.2fa.setup.activated": "2FA activated",
    "auth.2fa.setup.invalid_code": "Invalid code. Try again.",
    "auth.2fa.setup.code_required": "Enter the 6-digit code.",
    "auth.2fa.setup.error_setup": "Could not start setup. Try again.",
    "auth.2fa.status.active": "2FA is active",
    "auth.2fa.status.active_desc": "Your account is protected with two-factor authentication.",
    "auth.2fa.disable.title": "Disable 2FA",
    "auth.2fa.disable.warning": "Your account will be less protected.",
    "auth.2fa.disable.password_label": "Current password",
    "auth.2fa.disable.password_placeholder": "Your password",
    "auth.2fa.disable.code_label": "Verification code",
    "auth.2fa.disable.code_placeholder": "6-digit code or recovery code",
    "auth.2fa.disable.code_hint": "Enter your TOTP code or a recovery code (XXXXXXXX-XXXXXXXX).",
    "auth.2fa.disable.button": "Disable 2FA",
    "auth.2fa.disable.fields_required": "Password and code are required.",
    "auth.2fa.disable.success": "Two-factor authentication disabled.",
    "auth.2fa.disable.error": "Could not disable 2FA. Check your credentials.",
    "auth.2fa.banner.text": "Protect your account with two-factor authentication",
    "auth.2fa.banner.cta": "Enable now",
    "auth.2fa.banner.dismiss": "Remind me later",
    "auth.2fa.challenge.title": "Two-step verification",
    "auth.2fa.challenge.code_label": "6-digit code",
    "auth.2fa.challenge.recovery_label": "Recovery code",
    "auth.2fa.challenge.use_recovery": "Use a recovery code instead",
    "auth.2fa.challenge.use_totp": "Use authenticator app code",
    "auth.2fa.challenge.expires_in": "Expires in {seconds}",
    "auth.2fa.challenge.verify": "Verify",
    "auth.2fa.challenge.back_to_login": "Back to sign in",
    "auth.2fa.challenge.expired": "Session expired. Please sign in again.",
    "auth.2fa.challenge.invalid_code": "Invalid code. Try again.",
    "auth.2fa.challenge.code_required": "Enter the 6-digit code.",
    "auth.2fa.challenge.recovery_required": "Enter your recovery code.",
    "auth.2fa.challenge.too_many_attempts": "Too many attempts. Please sign in again.",
    "auth.2fa.challenge.recovery_low": "Only {n} recovery codes remaining. Regenerate them in Account Settings.",
    "common.loading": "Loading...",
    "common.copy": "Copy",
    "common.save": "Save",
    // S17b — Framework Picker (ADR-S17b-003)
    "settings.frameworks.title": "Active frameworks",
    "settings.frameworks.subtitle": "Choose which standards your organization uses.",
    "settings.frameworks.counter_suffix": "frameworks active",
    "settings.frameworks.over_cap_badge": "Over limit",
    "settings.frameworks.over_cap": "You exceeded your plan by {excess}. Remove frameworks or upgrade your plan.",
    "settings.frameworks.upgrade_cta": "Upgrade plan",
    "settings.frameworks.read_only": "Only the organization owner or admin can change framework selection.",
    "settings.frameworks.saved": "Frameworks updated",
    "settings.frameworks.save_failed": "Could not save framework selection",
    "settings.frameworks.load_failed": "Could not load framework data",
    "settings.frameworks.help_text": "Reference frameworks (NIST CSF 2.0, ISO 31000, ISO 22301) are always active and do not count toward your cap.",
    "settings.frameworks.billing_link": "Manage plan",
    "settings.frameworks.locked_reference_badge": "Reference (included)",
    "settings.frameworks.group_core": "IT Compliance",
    "settings.frameworks.group_rd_latam": "DR Government (NORTIC)",
    "settings.frameworks.group_sectorial": "Regulated sectors (Banking, Telecom)",
    "settings.frameworks.group_zona_franca": "Free Trade Zone",
    "settings.frameworks.group_reference": "Cross-mapping references",
    // P0-B (OBS-018) — Register Wizard bilingual onboarding (T5)
    "register.full_name_placeholder": "Jane Doe",
    "register.email_placeholder": "you@company.com",
    "register.password_placeholder": "At least 10 characters",
    "register.show_password": "Show password",
    "register.hide_password": "Hide password",
    "register.pwd_check_length": "10-128 characters",
    "register.pwd_check_classes": "3 of: lowercase, uppercase, digits, symbols",
    "register.org_name_placeholder": "Acme Inc.",
    "register.business_type": "Business type",
    "register.internal_team": "Internal team",
    "register.internal_team_desc": "We use ComplianceOS for our own organization",
    "register.consultant_mssp": "Consultant / MSSP",
    "register.consultant_mssp_desc": "We manage compliance for multiple clients",
    "register.industry": "Industry (optional)",
    "register.industry_placeholder": "e.g., FinTech",
    "register.country": "Country (optional)",
    "register.country_placeholder": "e.g., MX",
    "register.standards_label": "Standards to enable",
    "register.standards_hint": "Pick the frameworks your organization needs. You can change this later.",
    "register.expected_users": "Expected users",
    "register.expected_users_hint": "Used to recommend a plan and price your subscription.",
    "register.price.estimated_plan": "Estimated Professional plan",
    "register.price.base": "Base",
    "register.price.includes": "Includes",
    "register.price.and": "and",
    "register.price.extra_standard_one": "{n} extra standard",
    "register.price.extra_standard_other": "{n} extra standards",
    "register.price.extra_user_one": "{n} extra user",
    "register.price.extra_user_other": "{n} extra users",
    "register.price.standard_one": "{n} standard",
    "register.price.standard_other": "{n} standards",
    "register.price.users": "{n} users",
    "register.client_tenants": "Client tenants",
    "register.client_tenants_hint": "Each tenant becomes its own org with isolated data and standards.",
    "register.add_tenant": "Add tenant",
    "register.no_tenants_yet": "No tenants yet. Add at least one to continue.",
    "register.tenant_number": "Tenant #{n}",
    "register.tenant_name": "Tenant name",
    "register.tenant_name_placeholder": "e.g., Globex Corp",
    "register.standards": "Standards",
    "register.create_account": "Create Account",
    "register.creating_account": "Creating account...",
    "register.legal_disclaimer": "By creating an account you agree to receive a confirmation email.",
    "register.err_name_required": "Name is required",
    "register.err_email_required": "Email is required",
    "register.err_password_requirements": "Password must be 10-128 chars and use 3 of: lowercase, uppercase, digits, symbols",
    "register.err_org_required": "Organization name is required",
    "register.err_standard_required": "Select at least one standard",
    "register.err_users_min": "Expected users must be at least 1",
    "register.err_tenant_required": "Add at least one client tenant",
    "register.err_tenant_name_required": "All tenants must have a name",
    "register.err_tenant_standard_required": "Tenant \"{name}\" needs at least one standard",
    // P0-B (OBS-018) — SoA i18n completion (T6)
    "soa.loading": "Loading Statement of Applicability",
    "soa.all_statuses": "All Statuses",
    "soa.showing_of_entries": "Showing {x} of {y} entries",
    "soa.no_entries": "No SoA entries found",
    "soa.no_entries_hint": "Generate a SoA for a framework to get started",
    "soa.mapped": "mapped",
    "soa.edit_entry": "Edit SoA Entry",
    "soa.responsible": "Responsible",
    "soa.responsible_placeholder": "e.g., IT Security Team",
    "soa.justification_placeholder": "Why is this control applicable/not applicable?",
    "soa.notes_placeholder": "Additional implementation notes...",
    "soa.cross_framework_mappings": "Cross-Framework Mappings",
    "soa.toast_generate_failed": "Failed to generate SoA",
    "soa.toast_entry_updated": "Entry updated",
    "soa.toast_update_failed": "Failed to update entry",
    // P2 — confirm/prompt dialog sweep (ESignatureSettings/MultiTenancy/Billing/Documents/PlatformAdmin)
    "esig.delete_config_title": "Delete configuration",
    "esig.delete_config_desc": "Delete e-signature configuration?",
    "mt.switch_title": "Switch tenant",
    "mt.switch_desc_prefix": "Switch to",
    "mt.switch_desc_suffix": "? Reload the page to see this client's data.",
    "billing.switch_title": "Switch plan",
    "billing.switch_desc_prefix": "Switch to",
    "billing.switch_desc_suffix": "? This will update your subscription.",
    "docs.publish_title": "Publish document",
    "docs.publish_desc_prefix": "Publish",
    "docs.publish_desc_suffix": "? This makes the document final.",
    "docs.review_comment_title": "Submit for review",
    "docs.review_comment_label": "Comment for reviewer (optional)",
    "docs.approval_comment_title": "Approve document",
    "docs.approval_comment_label": "Approval comment (optional)",
    "padmin.delete_tier_title": "Delete plan",
    "padmin.delete_tier_desc_prefix": "Delete plan",
    "padmin.delete_tier_desc_suffix": "?",
    "padmin.reset_tiers_title": "Reset to defaults",
    "padmin.reset_tiers_desc": "Reset to the 3 default plans? Non-standard plans with no subscribers will be removed.",
    "padmin.revoke_admin_title": "Revoke super-admin",
    "padmin.revoke_admin_desc_prefix": "Revoke super-admin from",
    "padmin.revoke_admin_desc_suffix": "?",
    "padmin.override_title": "Assign plan",
    "padmin.override_tier_label": "Tier",
    "padmin.override_price_label": "Monthly price override (blank = standard)",
    "padmin.override_note_label": "Note",
    "padmin.override_save": "Assign",
  },

  es: {
    // Sidebar Groups
    "nav.overview": "Vista General", "nav.compliance": "Cumplimiento", "nav.risk_threats": "Riesgos y Amenazas",
    "nav.governance": "Gobernanza", "nav.organization": "Organización", "nav.reports": "Reportes y Analitica",
    "nav.ai_tools": "Herramientas IA", "nav.settings": "Configuración",
    // Nav Items
    "nav.dashboard": "Panel Principal", "nav.calendar": "Calendario", "nav.controls": "Biblioteca de Controles",
    "nav.soa": "Declaración de Aplicabilidad", "nav.gap_analysis": "Análisis de Brechas",
    "nav.certification": "Preparación Certificación", "nav.mappings": "Mapeo de Marcos",
    "nav.risks": "Registro de Riesgos", "nav.heatmap": "Mapa de Calor de Riesgos",
    "nav.threat_intel": "Inteligencia de Amenazas", "nav.vuln_scanner": "Escaner de Vulnerabilidades",
    "nav.risk_predictor": "IA Inteligencia de Riesgos", "nav.documents": "Documentos",
    "nav.evidence": "Evidencias", "nav.audits": "Auditorías Internas",
    "nav.mgmt_review": "Revisión por la Dirección", "nav.corrective_actions": "Acciones Correctivas",
    "nav.incidents": "Incidentes", "nav.vendors": "Riesgo de Proveedores",
    "nav.training": "Capacitación y Concienciación", "nav.maintenance": "Mantenimiento",
    "nav.reports_export": "Reportes y Exportación", "nav.exec_report": "Reporte Ejecutivo",
    "nav.benchmarking": "Benchmarking", "nav.policy_gen": "Generador de Políticas",
    "nav.wizard": "Asistente de Implementación", "nav.email": "Configuración de Email",
    "nav.rbac": "Control de Acceso", "nav.tenants": "Multi-Tenencia", "nav.billing": "Facturación",
    "nav.esignature": "Firma Electronica", "nav.frameworks": "Marcos",
    "nav.platform_admin": "Administración de Plataforma",
    "nav.portal": "Portal de Clientes", "nav.bulk": "Importación/Exportación Masiva",
    "nav.evidence_collection": "Evidencia Automatica",
    "nav.zona_franca": "Zona Franca",
    "nav.zf_overview": "Resumen ZF", "nav.zf_oea": "OEA", "nav.zf_cnzfe": "CNZFE 522-06",
    "nav.zf_iso22000": "ISO 22000", "nav.zf_bpm": "BPM", "nav.zf_haccp": "HACCP",
    "nav.zf_nordom477": "NORDOM 477",
    // UX strings — added during ES consistency pass
    "ux.no_projects_yet": "Aun no hay proyectos. Crea uno para comenzar a trabajar por cliente.",
    "ux.published": "Publicados", "ux.draft": "Borradores", "ux.archived": "Archivados",
    "ux.framework_compliance": "Cumplimiento de Marcos",
    "ux.corrective_actions": "Acciones Correctivas",
    "ux.risk_posture": "Postura de Riesgo",
    "ux.maintenance": "Mantenimiento",
    "ux.incident_resolution": "Resolución de Incidentes",
    "ux.compliance_score_trend": "Tendencia de Puntaje de Cumplimiento",
    "ux.compliance_score_trend_desc": "Puntajes de cumplimiento por marco en los ultimos 90 dias",
    "ux.total_risks": "Total de Riesgos",
    "ux.showing_of_controls": "Mostrando {x} de {y} controles",
    "ux.organizational": "Organizacional",
    "ux.risk_distribution": "Distribución de Riesgos",
    "ux.incident_summary": "Resumen de Incidentes",
    "ux.likelihood_vs_impact": "Matriz Probabilidad vs Impacto",
    "ux.click_cell_hint": "Haz clic en una celda para ver los riesgos en esa posición",
    "ux.likelihood": "Probabilidad", "ux.impact": "Impacto",
    "ux.clear_filters": "Limpiar filtros",
    "ux.upgrade_to_pro": "Disponible en Plan Professional",
    "ux.upgrade_cta": "Ver planes",
    // Health Score breakdown labels
    "health.compliance": "Cumplimiento de Marcos",
    "health.corrective_actions": "Acciones Correctivas",
    "health.risk_posture": "Postura de Riesgo",
    "health.maintenance": "Mantenimiento",
    "health.incidents": "Resolución de Incidentes",
    // Common
    "save": "Guardar", "cancel": "Cancelar", "delete": "Eliminar", "create": "Crear", "edit": "Editar",
    "search": "Buscar", "filter": "Filtrar", "export": "Exportar", "import": "Importar",
    "loading": "Cargando...", "no_data": "Sin datos disponibles", "status": "Estado",
    "actions": "Acciones", "all": "Todos", "active": "Activo", "completed": "Completado",
    "open": "Abierto", "closed": "Cerrado", "yes": "Si", "no": "No", "back": "Volver",
    "next": "Siguiente", "submit": "Enviar", "download": "Descargar", "copy": "Copiar",
    "copied": "Copiado", "generate": "Generar", "generating": "Generando...",
    "new": "Nuevo", "add": "Agregar", "remove": "Quitar", "update": "Actualizar",
    "details": "Detalles", "description": "Descripción", "title": "Título",
    "notes": "Notas", "optional": "Opcional",
    "date": "Fecha", "owner": "Responsable", "priority": "Prioridad", "category": "Categoría",
    "type": "Tipo", "total": "Total", "score": "Puntuación", "name": "Nombre",
    "email_label": "Correo", "password": "Contrasena", "confirm": "Confirmar",
    "critical": "Critico", "high": "Alto", "medium": "Medio", "low": "Bajo", "moderate": "Moderado",
    "in_progress": "En Progreso", "not_started": "Sin Iniciar", "overdue": "Vencido",
    "implemented": "Implementado", "not_applicable": "No Aplica", "pending": "Pendiente",
    "paused": "Pausado",
    // Auth
    "auth.sign_in": "Iniciar Sesión", "auth.sign_up": "Registrarse", "auth.email": "Correo Electrónico",
    "auth.password": "Contraseña", "auth.name": "Nombre Completo", "auth.org_name": "Nombre de Organización",
    "auth.back_to_home": "Volver al Inicio", "auth.signing_in": "Iniciando sesión...",
    "auth.logout": "Cerrar Sesión", "auth.welcome": "Bienvenido a ComplianceOS",
    "auth.subtitle": "Plataforma de Gestión de Cumplimiento Multi-Marco",
    "auth.no_account": "No tienes cuenta?", "auth.have_account": "Ya tienes cuenta?",
    "auth.or_continue": "O continuar con", "auth.google": "Continuar con Google",
    // Language
    "lang.title": "Idioma", "lang.en": "Ingles", "lang.es": "Espanol",
    // Dashboard labels
    "dashboard.loading": "Cargando panel...",
    "dashboard.total_risks": "Riesgos Totales",
    "dashboard.new": "Nuevo", "dashboard.investigating": "Investigando", "dashboard.closed": "Cerrado",
    "dashboard.trend_placeholder": "Los datos de tendencia apareceran cuando se registren puntajes de cumplimiento",
    "dashboard.documents": "Documentos", "dashboard.assets_tracked": "Activos Registrados",
    "dashboard.compliance_status": "Estado de Cumplimiento",
    "dashboard.on_track": "En Camino", "dashboard.needs_attention": "Requiere Atención",
    "dashboard.critical": "Critico",
    // Controls
    "ctrl.list_title": "Biblioteca de Controles", "ctrl.list_subtitle": "Explora todos los controles de cumplimiento por marco",
    "ctrl.total": "Controles Totales", "ctrl.framework": "Marco",
    "docs.title": "Documentos", "docs.subtitle": "Gestiona políticas, procedimientos y documentos de cumplimiento",
    "docs.upload": "Subir Documento",
    "inc.title": "Incidentes", "inc.subtitle": "Rastrea y gestiona incidentes de seguridad",
    "inc.new": "Reportar Incidente",
    "audits.title": "Auditorías Internas", "audits.subtitle": "Planifica, ejecuta y rastrea auditorías internas",
    "audits.new": "Nueva Auditoría",
    // Evidence
    "evid.title": "Repositorio de Evidencias", "evid.subtitle": "Biblioteca central de evidencias para auditorías",
    "evid.new": "Agregar Evidencia",
    // Management Review
    "mr.title": "Revisión por la Dirección", "mr.subtitle": "Revisiones de liderazgo del sistema de cumplimiento (ISO)",
    "mr.new": "Nueva Revisión",
    "mr.loading": "Cargando revisiones por la dirección...",
    "mr.schedule_first": "Agenda tu Primera Revisión",
    "mr.title_placeholder": "Ej.: Q1 2026 Revisión del SGSI por la Dirección",
    "mr.agenda_default_hint": "Puntos de Agenda (se usaran puntos por defecto si queda vacio)",
    "mr.change_status": "Cambiar Estado",
    "mr.system_inputs": "Entradas del Sistema (autocompletadas)",
    "mr.compliance_score": "Puntuación de Cumplimiento",
    "mr.open_ncs": "No Conformidades Abiertas",
    "mr.recent_incidents": "Incidentes Recientes",
    "mr.assets_tracked": "Activos Registrados",
    "mr.agenda_label": "Puntos de Agenda",
    "mr.decisions_made": "Decisiones Tomadas",
    "mr.no_decisions": "Aun no hay decisiones registradas",
    "mr.add_decision_ph": "Agregar una decisión...",
    "mr.owner": "Responsable",
    "mr.due": "Fecha límite",
    "mr.action_items": "Acciones a Tomar",
    "mr.no_action_items": "Aun no hay acciones",
    "mr.action_desc_ph": "Descripción de la acción...",
    "mr.action_owner_ph": "Responsable",
    "mr.attendees": "asistentes",
    "mr.action_items_count": "acciones",
    // Management Review agenda preview keys (mirror DEFAULT_AGENDA_BY_LOCALE en backend)
    "mr.agenda.isms_performance": "Revisión del desempeno del SGSI/SGS",
    "mr.agenda.ca_status": "Estado de las acciones correctivas",
    "mr.agenda.changes": "Cambios que afectan al sistema de gestión",
    "mr.agenda.improvements": "Oportunidades de mejora",
    "mr.agenda.resources": "Requerimientos de recursos",
    "mr.agenda.risk_review": "Revisión del analisis de riesgos",
    // Management Review toasts
    "mr.toast.title_date_required": "Por favor ingresa un titulo y fecha",
    "mr.toast.created": "Revisión por la dirección creada",
    "mr.toast.create_failed": "Error al crear la revisión",
    "mr.toast.status_updated": "Estado actualizado",
    "mr.toast.status_failed": "Error al actualizar el estado",
    "mr.toast.decision_added": "Decision registrada",
    "mr.toast.decision_failed": "Error al registrar la decision",
    "mr.toast.action_added": "Acción agregada",
    "mr.toast.action_failed": "Error al agregar la acción",
    // Corrective Actions
    "ca.title": "Acciones Correctivas", "ca.subtitle": "Gestiona no conformidades y acciones de mejora",
    "ca.new": "Nueva Acción",
    // Reports
    "rep.title": "Reportes y Exportación", "rep.subtitle": "Genera y exporta reportes de cumplimiento",
    "rep.export_pdf": "Exportar PDF",
    // Calendar
    "cal.title": "Calendario de Cumplimiento", "cal.subtitle": "Eventos, plazos y revisiones de cumplimiento",
    "cal.new": "Nuevo Evento",
    // Mappings
    "map.title": "Mapeos de Marcos", "map.subtitle": "Mapeos cruzados de controles entre marcos",
    // Vendors
    "vend.title": "Riesgo de Proveedores", "vend.subtitle": "Evalúa y gestiona riesgo de terceros",
    "vend.new": "Agregar Proveedor",
    // Training
    "train.title": "Capacitación y Concientización", "train.subtitle": "Programas de capacitación de seguridad",
    "train.new": "Nueva Capacitación",
    // Heat Map
    "heat.title": "Mapa de Calor de Riesgos", "heat.subtitle": "Visualiza riesgos por impacto y probabilidad",
    // Certification
    "cert.title": "Preparación para Certificación", "cert.subtitle": "Rastrea preparación para auditorías ISO/NIST",
    // Benchmarking
    "bench.title": "Benchmarking", "bench.subtitle": "Compara tu postura contra estándares de industria",
    // Policy Generator
    "pol.title": "Generador de Políticas", "pol.subtitle": "Redacción de políticas y procedimientos con IA",
    // Threat Intel
    "ti.title": "Threat Intelligence", "ti.subtitle": "Ultimos indicadores de amenazas y compromisos",
    // Vuln Scanner
    "vuln.title": "Escaner de Vulnerabilidades", "vuln.subtitle": "Vulnerabilidades detectadas por escaneres conectados",
    // Risk Predictor
    "pred.title": "Inteligencia de Riesgo IA", "pred.subtitle": "Analitica predictiva sobre tu registro de riesgos",
    // Wizard
    "wiz.title": "Asistente de Implementación", "wiz.subtitle": "Guía paso a paso con IA para implementar controles",
    // Maintenance
    "mnt.title": "Mantenimiento", "mnt.subtitle": "Mantenimiento programado y revisiones del sistema",
    // Email settings
    "email.title": "Configuración de Email", "email.subtitle": "Configura SMTP para notificaciones",
    // RBAC
    "rbac.title": "Control de Acceso (RBAC)", "rbac.subtitle": "Gestiona roles y permisos de usuario",
    // Bulk
    "bulk.title": "Import/Export Masivo", "bulk.subtitle": "Cargar o descargar datos masivamente",
    // Client Portal
    "portal.title": "Portal del Cliente", "portal.subtitle": "Genera enlaces seguros de solo lectura para stakeholders",
    // Tenant
    "tenant.title": "Multi-Tenencia", "tenant.subtitle": "Gestiona organizaciones cliente y tenants",
    "tenant.new_org": "Nueva Organización", "tenant.managed": "Organizaciones Gestionadas",
    "tenant.health": "Puntaje de Salud", "tenant.switch": "Cambiar A", "tenant.domain": "Dominio",
    // Evidence Collection
    "evcoll.title": "Recolección Automatica de Evidencia", "evcoll.subtitle": "Auditoría automatica de servicios en la nube",
    "evcoll.configure": "Configurar", "evcoll.collect": "Recolectar",
    "evcoll.collecting": "Recolectando...", "evcoll.last_run": "Ultima ejecución", "evcoll.items_collected": "Elementos",
    // Notifications
    "notif.title": "Notificaciones", "notif.mark_all": "Marcar todas leidas",
    "notif.no_notifications": "Sin notificaciones", "notif.refresh": "Actualizar",
    // Dashboard
    "dashboard.title": "Panel Principal", "dashboard.subtitle": "Resumen de cumplimiento y metricas clave",
    "dashboard.overall": "Puntuación General de Cumplimiento", "dashboard.health": "Índice de Salud de Cumplimiento",
    "dashboard.trend": "Tendencia de Cumplimiento", "dashboard.trend_desc": "Puntuaciones por marco en los ultimos 90 dias",
    "dashboard.risk_dist": "Distribución de Riesgos", "dashboard.recent_incidents": "Incidentes Recientes",
    "dashboard.fw_scores": "Puntuaciones por Marco", "dashboard.welcome": "Bienvenido de nuevo",
    "dashboard.quick_stats": "Estadísticas Rápidas",
    "dashboard.greeting_morning": "Buenos días",
    "dashboard.greeting_afternoon": "Buenas tardes",
    "dashboard.greeting_evening": "Buenas noches",
    "dashboard.greeting_fallback": "usuario",
    "dashboard.export_success": "Reporte ejecutivo descargado",
    "dashboard.export_failed": "Error al exportar PDF",
    "dashboard.grade_label": "Calificación",
    "dashboard.active_frameworks": "Marcos activos:",
    // Controls
    "controls.title": "Biblioteca de Controles", "controls.subtitle": "Explorar controles de cumplimiento por marco",
    "controls.search_placeholder": "Buscar controles...", "controls.framework": "Marco",
    "controls.category": "Categoría", "controls.total_controls": "Total de Controles",
    // Risks
    "risks.title": "Registro de Riesgos", "risks.subtitle": "Gestionar activos, amenazas, vulnerabilidades y riesgos",
    "risks.assessments": "Evaluaciones de Riesgo (por Cliente)",
    "risks.new_assessment": "Nueva Evaluación de Riesgos",
    "risks.add_asset": "Agregar Activo", "risks.add_risk": "Agregar Riesgo",
    "risks.matrix": "Matriz de Riesgos", "risks.treatment": "Tratamiento", "risks.likelihood": "Probabilidad",
    "risks.impact": "Impacto", "risks.asset": "Activo", "risks.threat": "Amenaza",
    "risks.risk_category": "Categoría de Riesgo", "risks.risk_source": "Fuente del Riesgo",
    "risks.existing_controls": "Controles Existentes",
    "risks.ph_asset_desc": "Breve descripción del activo",
    "risks.ph_risk_desc": "Describe el escenario de riesgo",
    "risks.ph_select_asset": "Selecciona un activo", "risks.ph_select_threat": "Selecciona una amenaza (opcional)",
    "risks.ph_select_category": "Selecciona categoría", "risks.ph_select_source": "Selecciona fuente",
    "risks.ph_existing_controls": "Describe los controles actuales...",
    "risks.add": "Agregar Riesgo", "risks.likelihood": "Probabilidad", "risks.impact": "Impacto",
    "risks.score": "Puntuación de Riesgo", "risks.level": "Nivel de Riesgo", "risks.treatment": "Tratamiento",
    "risks.owner": "Responsable del Riesgo", "risks.category": "Categoría de Riesgo", "risks.source": "Fuente del Riesgo",
    "risks.residual": "Riesgo Residual", "risks.residual_score": "Puntuación de Riesgo Residual",
    "risks.cia": "Evaluación de Impacto CIA (ISO 27005)", "risks.confidentiality": "Confidencialidad",
    "risks.integrity": "Integridad", "risks.availability": "Disponibilidad",
    "risks.existing_controls": "Controles Existentes", "risks.appetite": "Apetito de Riesgo",
    "risks.review_freq": "Frecuencia de Revisión", "risks.iso_assessment": "Evaluación ISO 31000 / ISO 27005",
    "risks.accept": "Aceptar", "risks.mitigate": "Mitigar", "risks.transfer": "Transferir", "risks.avoid": "Evitar",
    "risks.strategic": "Estrategico", "risks.operational": "Operacional", "risks.compliance": "Cumplimiento",
    "risks.financial": "Financiero", "risks.reputational": "Reputacional", "risks.technological": "Tecnologico",
    "risks.natural": "Natural",
    "risks.internal": "Interno", "risks.external": "Externo", "risks.environmental": "Ambiental",
    "risks.monthly": "Mensual", "risks.quarterly": "Trimestral", "risks.semi_annual": "Semestral", "risks.annual": "Anual",
    "risks.cat.strategic": "Estrategico", "risks.cat.operational": "Operacional", "risks.cat.compliance": "Cumplimiento",
    "risks.cat.financial": "Financiero", "risks.cat.reputational": "Reputacional",
    "risks.cat.technological": "Tecnologico", "risks.cat.natural": "Natural",
    "risks.source.internal": "Interno", "risks.source.external": "Externo",
    "risks.source.environmental": "Ambiental",
    "risks.new_risk_title": "Agregar Nuevo Riesgo", "risks.new_risk_desc": "Crea una nueva entrada de riesgo en tu registro",
    "risks.new_asset_title": "Agregar Nuevo Activo", "risks.new_asset_desc": "Agrega un activo a tu inventario para evaluación de riesgo",
    "risks.asset_name": "Nombre del Activo", "risks.asset_type": "Tipo de Activo", "risks.asset_desc": "Descripción",
    "risks.asset_type.hardware": "Hardware", "risks.asset_type.software": "Software",
    "risks.asset_type.data": "Datos", "risks.asset_type.service": "Servicio", "risks.asset_type.people": "Personas",
    "risks.confidentiality": "Confidencialidad", "risks.integrity": "Integridad", "risks.availability": "Disponibilidad",
    "risks.title_label": "Titulo del Riesgo", "risks.related_asset": "Activo Relacionado", "risks.threat_label": "Amenaza",
    "risks.risk_score": "Puntuación de Riesgo", "risks.residual_likelihood": "Probabilidad Residual",
    "risks.residual_impact": "Impacto Residual", "risks.residual_risk_score": "Puntuación de Riesgo Residual",
    "risks.relevant_frameworks": "Marcos Relevantes",
    "risks.ph_appetite": "Selecciona apetito", "risks.ph_frequency": "Selecciona frecuencia",
    "risks.ph_risk_title": "ej., Acceso no autorizado a datos de clientes",
    "risks.ph_asset_name": "ej., Servidor de Base de Datos de Producción",
    "risks.save_changes": "Guardar Cambios", "risks.add_btn": "Agregar Riesgo",
    "risks.add_asset_btn": "Agregar Activo",
    "risks.delete_confirm_title": "Eliminar Riesgo",
    "risks.delete_confirm_desc": "Estas seguro de que deseas eliminar este riesgo? Esta acción no se puede deshacer.",
    "risks.no_risks": "No hay riesgos registrados aun",
    "risks.no_risks_desc": "Comienza a rastrear riesgos en tus activos y marcos.",
    "risks.no_risks_filter": "Ningun riesgo coincide con tus filtros",
    "risks.no_risks_filter_desc": "Intenta limpiar la busqueda o cambiar el filtro de nivel.",
    "risks.add_first": "Agregar tu primer riesgo",
    "risks.score_label": "Puntuación de Riesgo:",
    "risks.cia_section": "Evaluación de Impacto CIA (ISO 27005)",
    "risks.load_from_catalog": "Cargar del Catalogo de Riesgos",
    "risks.catalog_placeholder": "Selecciona del catalogo (opcional)",
    "risks.template_applied": "Plantilla aplicada — editable",
    // SoA
    "soa.title": "Declaración de Aplicabilidad", "soa.subtitle": "Gestionar aplicabilidad e implementación de controles",
    "soa.generate": "Generar SoA",
    "soa.applicable": "Aplicable", "soa.justification": "Justificación",
    "soa.implementation": "Estado de Implementación",
    "soa.assessments": "Proyectos SoA (por Cliente)",
    "soa.new_assessment": "Nuevo Proyecto SoA",
    // Documents
    "docs.title": "Gestión de Documentos", "docs.subtitle": "Cargar, versionar y gestionar documentos de cumplimiento",
    "docs.new": "Nuevo Documento", "docs.upload": "Cargar", "docs.version": "Versión",
    "docs.published": "Publicado", "docs.draft": "Borrador", "docs.archived": "Archivado",
    // Evidence
    "evidence.title": "Gestión de Evidencias", "evidence.subtitle": "Recopilar y vincular evidencias a controles",
    "evidence.new": "Nueva Evidencia", "evidence.linked_controls": "Controles Vinculados",
    "evidence.collection_method": "Metodo de Recolección", "evidence.period": "Periodo Cubierto",
    // Audits
    "audits.title": "Auditorías Internas", "audits.subtitle": "Planificar, ejecutar y dar seguimiento a auditorías",
    "audits.new": "Nueva Auditoría", "audits.lead": "Auditor Lider", "audits.scope": "Alcance",
    "audits.planned": "Planificada", "audits.findings": "Hallazgos",
    "audits.nc": "No Conformidades", "audits.nc_new": "Nueva No Conformidad",
    // Incidents
    "incidents.title": "Gestión de Incidentes", "incidents.subtitle": "Rastrear y gestionar incidentes de seguridad",
    "incidents.new": "Nuevo Incidente", "incidents.severity": "Severidad",
    "incidents.workflow": "Paso del Flujo", "incidents.reported_by": "Reportado Por",
    "incidents.investigating": "Investigando", "incidents.contained": "Contenido",
    "incidents.resolved": "Resuelto",
    // Management Review
    "review.title": "Revisión por la Dirección", "review.subtitle": "Programar y realizar revisiones por la dirección",
    "review.new": "Nueva Revisión", "review.agenda": "Agenda", "review.decisions": "Decisiones",
    "review.action_items": "Elementos de Acción", "review.scheduled": "Programada",
    // Corrective Actions
    "ca.title": "Acciones Correctivas", "ca.subtitle": "Gestionar acciones correctivas de auditorías, incidentes y revisiones",
    "ca.new": "Nueva Acción Correctiva", "ca.root_cause": "Causa Raiz",
    "ca.action_plan": "Plan de Acción", "ca.effectiveness": "Revisión de Efectividad",
    "ca.closure_rate": "Tasa de Cierre",
    // Maintenance
    "maint.title": "Calendario de Mantenimiento", "maint.subtitle": "Programar y dar seguimiento a tareas recurrentes",
    "maint.new": "Nueva Tarea", "maint.frequency": "Frecuencia", "maint.due_date": "Fecha de Vencimiento",
    "maint.last_completed": "Ultima Completada", "maint.due_this_week": "Vence Esta Semana",
    "maint.complete": "Marcar Completa",
    "maint.daily": "Diaria", "maint.weekly": "Semanal", "maint.monthly": "Mensual",
    "maint.quarterly": "Trimestral", "maint.semi_annual": "Semestral", "maint.annual": "Anual",
    "maint.policy_review": "Revisión de Políticas", "maint.control_update": "Actualización de Controles",
    "maint.cert_renewal": "Renovación de Certificados", "maint.training": "Capacitación",
    "maint.backup_verify": "Verificación de Respaldos", "maint.access_review": "Revisión de Accesos",
    "maint.vuln_scan": "Escaneo de Vulnerabilidades", "maint.other": "Otro",
    // Mappings
    "mappings.title": "Mapeo entre Marcos", "mappings.subtitle": "Mapeo de controles entre marcos de cumplimiento",
    // Gap Analysis
    "gap.title": "Análisis de Brechas", "gap.subtitle": "Evaluación automatizada de brechas por marco",
    "gap.coverage": "Cobertura", "gap.gaps_found": "brechas encontradas", "gap.recommendations": "Recomendaciones",
    "gap.no_evidence": "Sin evidencia vinculada", "gap.not_implemented": "Control no implementado completamente",
    "gap.new_project": "Nuevo Proyecto GAP", "gap.projects": "Proyectos GAP",
    "gap.no_projects": "Aun no hay proyectos GAP. Haz clic en 'Nuevo GAP' para iniciar tu primera evaluación.",
    "gap.select_client": "Seleccionar Organización Cliente", "gap.client_required": "Primero crea un tenant cliente en Multi-Tenencia",
    "gap.project_name": "Nombre del Proyecto", "gap.contact_name": "Nombre del Contacto", "gap.contact_email": "Correo del Contacto",
    "gap.responsible": "Responsable (Consultor)", "gap.framework_select": "Marco / Estandar",
    "gap.notes": "Notas", "gap.run_assessment": "Ejecutar Evaluación GAP", "gap.view_details": "Ver Detalles",
    "gap.mark_completed": "Marcar como Completado", "gap.run_again": "Re-ejecutar",
    "gap.last_run": "Ultima ejecución", "gap.never_run": "Aun no ejecutado",
    "gap.overview": "Vision Global", "gap.my_projects": "Mis Proyectos GAP",
    // Engagements
    "eng.status.in_progress": "En Progreso", "eng.status.completed": "Completado",
    "eng.status.on_hold": "En Pausa", "eng.status.cancelled": "Cancelado",
    // Certification
    "cert.title": "Preparación para Certificación", "cert.subtitle": "Evaluar si la organización está lista para auditoría de certificación",
    "cert.score": "Puntuación de Preparación", "cert.blockers": "Bloqueadores de Certificación",
    "cert.blockers_desc": "Problemas que deben resolverse antes de la certificación",
    "cert.no_blockers": "Sin bloqueadores! Estas listo para la certificación.",
    "cert.breakdown": "Desglose de Puntuación", "cert.next_steps": "Próximos Pasos",
    "cert.ready": "Listo para Auditoría de Certificación", "cert.almost": "Casi Listo - Brechas Menores",
    "cert.in_progress": "En Progreso - Trabajo Significativo Necesario", "cert.not_ready": "No Listo - Implementación Mayor Requerida",
    // Reports
    "reports.title": "Reportes y Exportaciones", "reports.subtitle": "Resumen ejecutivo y generación de reportes PDF",
    "reports.export_pdf": "Exportar PDF", "reports.sections": "Secciones del Reporte",
    "reports.sections_desc": "Seleccionar que incluir en el PDF",
    "reports.compliance_scores": "Puntuaciones de Cumplimiento", "reports.risk_summary": "Resumen de Riesgos",
    "reports.incident_summary": "Resumen de Incidentes", "reports.audit_summary": "Resumen de Auditorías",
    "reports.ca_summary": "Acciones Correctivas", "reports.doc_summary": "Resumen de Documentos",
    // Exec Report
    "exec.title": "Generador de Reporte Ejecutivo", "exec.subtitle": "Reportes de cumplimiento para directivos con IA",
    "exec.focus": "Enfoque del Reporte", "exec.general": "Vision General", "exec.risk": "Postura de Riesgos",
    "exec.compliance": "Estado de Cumplimiento", "exec.incidents": "Análisis de Incidentes",
    "exec.improvement": "Progreso de Mejora", "exec.board_report": "Reporte para Directivos",
    // Benchmarking
    "bench.title": "Benchmarking de Cumplimiento", "bench.subtitle": "Compara tus puntuaciones contra promedios de la industria",
    "bench.percentile": "Ranking Percentil", "bench.industry_avg": "Promedio de Industria",
    "bench.median": "Mediana", "bench.top25": "Top 25%", "bench.top10": "Top 10%",
    "bench.gap_to_top": "para alcanzar el Top 25%", "bench.in_top": "Estas en el Top 25%!",
    "bench.sector_comparison": "Tu Puntuación vs. Sectores de Industria",
    "bench.sector_desc": "Verde = superas, Rojo = el sector te supera",
    "bench.distribution": "Distribución de Puntuaciones",
    // Policy Generator
    "policy.title": "Generador de Políticas", "policy.subtitle": "Generación de documentos de políticas y procedimientos con IA",
    "policy.generate_doc": "Generar Documento", "policy.control": "Control",
    "policy.doc_type": "Tipo de Documento", "policy.policy": "Política", "policy.procedure": "Procedimiento",
    "policy.guideline": "Guía", "policy.checklist": "Lista de Verificación",
    "policy.generated": "Documento Generado", "policy.select_generate": "Selecciona un control y haz clic en Generar",
    "policy.ai_desc": "La IA creara un documento completo listo para auditoría",
    // Vendor Risk
    "vendor.title": "Gestión de Riesgo de Proveedores", "vendor.subtitle": "Evaluar y monitorear riesgos de terceros (A.5.19-A.5.22)",
    "vendor.add": "Agregar Proveedor", "vendor.assess": "Evaluar", "vendor.questionnaire": "Evaluación de Seguridad",
    "vendor.questionnaire_desc": "Completar el cuestionario de seguridad para calcular la puntuación de riesgo",
    "vendor.submit_assessment": "Enviar Evaluación", "vendor.not_assessed": "No evaluado",
    "vendor.risk_score": "Puntuación de Riesgo", "vendor.contact": "Contacto",
    "vendor.data_access": "Nivel de Acceso a Datos", "vendor.criticality": "Criticidad",
    "vendor.services": "Servicios Proporcionados",
    "vendor.technology": "Tecnologia", "vendor.cloud": "Nube", "vendor.consulting": "Consultoria",
    "vendor.outsourcing": "Externalización",
    "vendor.none": "Ninguno", "vendor.limited": "Limitado", "vendor.significant": "Significativo", "vendor.full": "Completo",
    // Calendar
    "calendar.title": "Calendario de Cumplimiento", "calendar.subtitle": "Vista unificada de todas las fechas limite y eventos",
    "calendar.upcoming": "Próximos", "calendar.today": "Hoy",
    "calendar.all_events": "Todos los Eventos",
    "calendar.maintenance_type": "Mantenimiento", "calendar.ca_type": "Acción Correctiva",
    "calendar.audit_type": "Auditoría", "calendar.review_type": "Revisión", "calendar.risk_type": "Revisión de Riesgo",
    // Threat Intel
    "threat.title": "Inteligencia de Amenazas", "threat.subtitle": "Monitorear, analizar y responder a amenazas de seguridad",
    "threat.new": "Nueva Inteligencia", "threat.dashboard": "Panel", "threat.registry": "Registro de Inteligencia",
    "threat.mitre": "MITRE ATT&CK", "threat.global_threats": "Amenazas Globales",
    "threat.active": "Activa", "threat.monitoring": "Monitoreando", "threat.mitigated": "Mitigada",
    "threat.mitre_coverage": "Cobertura MITRE ATT&CK",
    "threat.mitre_desc": "Tacticas y tecnicas mapeadas desde tu inteligencia de amenazas",
    // Email Settings
    "email.title": "Configuración de Email", "email.subtitle": "Configurar SMTP para habilitar notificaciones por correo",
    "email.smtp_config": "Configuración del Servidor SMTP", "email.smtp_desc": "Conectar a cualquier proveedor SMTP",
    "email.quick_setup": "Configuración Rapida - Seleccionar Proveedor", "email.host": "Servidor SMTP",
    "email.port": "Puerto", "email.username": "Usuario", "email.from_email": "Email de Origen",
    "email.from_name": "Nombre de Origen", "email.test_config": "Probar Configuración",
    "email.test_desc": "Enviar un correo de prueba para verificar la configuración",
    "email.send_test": "Enviar Prueba", "email.sending": "Enviando...",
    "email.send_notif": "Enviar Notificaciones", "email.send_notif_desc": "Disparar notificaciones manualmente",
    "email.overdue_tasks": "Tareas Vencidas", "email.overdue_cas": "ACs Vencidas",
    "email.compliance_alert": "Alerta de Cumplimiento", "email.weekly_digest": "Resumen Semanal",
    "email.send_all": "Enviar Todas", "email.verified": "SMTP Verificado",
    "email.configured": "Configurado", "email.not_configured": "Configura SMTP primero",
    // RBAC
    "rbac.title": "Control de Acceso y Pista de Auditoría", "rbac.subtitle": "Gestionar roles, permisos y registro de actividad",
    "rbac.users": "Usuarios de la Organización", "rbac.users_desc": "Asignar roles para controlar acceso a módulos",
    "rbac.roles": "Definición de Roles", "rbac.audit_trail": "Pista de Auditoría", "rbac.recent": "Actividad reciente",
    // Training
    "training.title": "Capacitación y Concienciación", "training.subtitle": "Gestionar programas de concienciación (ISO 27001 A.6.3)",
    "training.new": "Nueva Capacitación", "training.programs": "Programas Totales",
    "training.completions": "Completados", "training.completion_rate": "Tasa de Completitud",
    "training.complete_btn": "Completar", "training.awareness": "Concienciación en Seguridad",
    "training.phishing": "Prevención de Phishing", "training.data_protection": "Protección de Datos",
    "training.incident_response": "Respuesta a Incidentes", "training.gdpr": "GDPR/Privacidad",
    "training.access_control": "Control de Acceso",
    // Risk Heat Map
    "heatmap.title": "Mapa de Calor de Riesgos", "heatmap.subtitle": "Visualización interactiva de riesgos por probabilidad e impacto",
    "heatmap.matrix": "Matriz Probabilidad vs Impacto", "heatmap.matrix_desc": "Haz clic en una celda para ver los riesgos",
    "heatmap.by_level": "Por Nivel de Riesgo", "heatmap.by_treatment": "Por Tratamiento", "heatmap.by_category": "Por Categoría",
    // Vuln Scanner
    "vuln.title": "Importación de Escaner de Vulnerabilidades", "vuln.subtitle": "Importar hallazgos a Inteligencia de Amenazas",
    "vuln.import": "Importar Escaneo", "vuln.manual": "Entrada Manual", "vuln.manual_title": "Entrada Manual de Vulnerabilidad",
    "vuln.how_to": "Como Importar", "vuln.findings": "Hallazgos (JSON)",
    "vuln.import_findings": "Importar Hallazgos", "vuln.importing": "Importando...",
    // Risk Predictor
    "predictor.title": "IA Inteligencia de Riesgos", "predictor.subtitle": "Analitica predictiva y simulaciones What-If",
    "predictor.tab_predict": "Predictor de Riesgos", "predictor.tab_scenarios": "Escenarios What-If",
    "predictor.analyze": "Predicción de Riesgos con IA", "predictor.analyze_desc": "Analizar datos historicos para predecir riesgos futuros",
    "predictor.run": "Ejecutar Análisis", "predictor.analyzing": "Analizando...",
    "predictor.custom": "Escenario Personalizado", "predictor.simulate": "Simular",
    "predictor.simulating": "Ejecutando simulación...",
    // Bulk
    "bulk.title": "Importación / Exportación Masiva", "bulk.subtitle": "Importar y exportar datos de cumplimiento en masa",
    "bulk.export_data": "Exportar Datos", "bulk.export_desc": "Descargar datos como JSON o CSV",
    "bulk.import_data": "Importar Datos", "bulk.import_desc": "Importar datos desde JSON",
    "bulk.module": "Modulo", "bulk.format": "Formato", "bulk.json_data": "Datos JSON",
    // Multi-Tenancy
    "tenant.title": "Gestión Multi-Inquilino", "tenant.subtitle": "Gestionar multiples organizaciones desde un panel unico",
    "tenant.new_org": "Nueva Organización", "tenant.managed": "Organizaciones Gestionadas",
    "tenant.switch": "Cambiar a esta org", "tenant.health": "Índice de Salud",
    "tenant.domain": "Dominio",
    // Client Portal
    "portal.title": "Portal de Clientes", "portal.subtitle": "Compartir vistas de cumplimiento de solo lectura",
    "portal.create_link": "Crear Enlace de Portal", "portal.label": "Etiqueta",
    "portal.modules": "Modulos", "portal.expires": "Expira En",
    "portal.views": "Visitas", "portal.token": "Token", "portal.no_links": "No hay enlaces de portal creados",
    // Evidence Collection
    "evcoll.title": "Recolección Automatica de Evidencias", "evcoll.subtitle": "Conectar plataformas cloud para recopilar evidencia automaticamente",
    "evcoll.configure": "Configurar", "evcoll.collect": "Recopilar Evidencia",
    "evcoll.collecting": "Recopilando...", "evcoll.last_run": "Ultima ejecución",
    "evcoll.items_collected": "Elementos recopilados",
    // Wizard
    "wizard.title": "Asistente de Implementación", "wizard.subtitle": "Implementación guiada paso a paso con IA para cada marco",
    "wizard.start": "Iniciar Implementación", "wizard.phases": "Fases de Implementación",
    "wizard.ai_expert": "Experto IA en Implementación", "wizard.select_phase": "Selecciona una fase para iniciar la guia con IA",
    "wizard.deliverables": "Entregables Clave",
    // Incidents extra keys
    "incidents.total": "Total de Incidentes", "incidents.open": "Incidentes Abiertos", "incidents.critical_p1": "Criticos (P1)",
    "incidents.resolved": "Resueltos",
    "incidents.search_ph": "Buscar incidentes...", "incidents.all_severities": "Todas las Severidades",
    "incidents.all_statuses": "Todos los Estados",
    "incidents.detected": "Detectado", "incidents.source_label": "Fuente",
    "incidents.no_incidents_title": "No hay incidentes que rastrear",
    "incidents.no_incidents_desc": "Todo tranquilo por ahora. Reporta cualquier evento de seguridad para que sea auditable.",
    "incidents.report_one": "Reportar un incidente",
    "incidents.new_sheet_title": "Reportar Nuevo Incidente",
    "incidents.new_sheet_desc": "Crear un nuevo registro de incidente de seguridad",
    "incidents.title_label": "Titulo del Incidente",
    "incidents.desc_label": "Descripción",
    "incidents.category_label": "Categoría",
    "incidents.detection_source_label": "Fuente de Detección",
    "incidents.create_btn": "Crear Incidente",
    "incidents.detail_detected": "Detectado",
    // Incident categories
    "inc.cat.data_breach": "Violación de Datos", "inc.cat.ransomware": "Ransomware",
    "inc.cat.phishing": "Phishing", "inc.cat.insider_threat": "Amenaza Interna",
    "inc.cat.ddos": "Ataque DDoS", "inc.cat.unauthorized_access": "Acceso No Autorizado",
    "inc.cat.system_failure": "Fallo del Sistema", "inc.cat.service_disruption": "Interrupción de Servicio",
    "inc.cat.physical_security": "Seguridad Fisica", "inc.cat.supply_chain": "Cadena de Suministro",
    "inc.cat.other": "Otro",
    // Incident severities
    "inc.sev.p1": "P1 - Critico", "inc.sev.p2": "P2 - Alto",
    "inc.sev.p3": "P3 - Medio", "inc.sev.p4": "P4 - Bajo",
    // Incident statuses
    "inc.status.new": "Nuevo", "inc.status.triaged": "Triaged",
    "inc.status.investigating": "Investigando", "inc.status.contained": "Contenido",
    "inc.status.eradicated": "Erradicado", "inc.status.recovering": "Recuperando",
    "inc.status.closed": "Cerrado",
    // Incident detection sources
    "inc.src.user_report": "Reporte de Usuario", "inc.src.siem_alert": "Alerta SIEM",
    "inc.src.threat_intel": "Inteligencia de Amenazas", "inc.src.vulnerability_scan": "Escaneo de Vulnerabilidades",
    "inc.src.third_party": "Tercero", "inc.src.internal_audit": "Auditoría Interna",
    "inc.src.other": "Otro",
    // Documents extra keys
    "docs.create_title": "Crear Nuevo Documento",
    "docs.create_desc": "Agrega una nueva política, procedimiento o documento de cumplimiento",
    "docs.title_label": "Titulo del Documento",
    "docs.type_label": "Tipo de Documento",
    "docs.framework_label": "Marco",
    "docs.content_label": "Contenido",
    "docs.folder_label": "Carpeta",
    "docs.create_btn": "Crear Documento",
    "docs.search_ph": "Buscar documentos...",
    "docs.all_statuses": "Todos los Estados",
    "docs.showing": "Mostrando {count} de {total} documentos",
    "docs.no_docs_title": "Aun no hay documentos",
    "docs.no_docs_desc": "Políticas, procedimientos, evidencias — mantenlos aqui, listos para auditoría.",
    "docs.create_first": "Crear tu primer documento",
    "docs.delete_title": "Eliminar Documento",
    "docs.delete_desc": "Estas seguro de que deseas eliminar este documento? Esta acción no se puede deshacer.",
    "docs.updated": "Actualizado",
    "docs.ph_content": "Contenido del documento...",
    "docs.ph_folder": "ej., Políticas, Procedimientos...",
    "docs.ph_title": "ej., Política de Seguridad de la Información",
    // Document types
    "docs.type.policy": "Política", "docs.type.procedure": "Procedimiento",
    "docs.type.plan": "Plan", "docs.type.register": "Registro",
    "docs.type.report": "Reporte", "docs.type.form": "Formulario",
    // Document statuses
    "docs.status.draft": "Borrador", "docs.status.under_review": "En Revisión",
    "docs.status.approved": "Aprobado", "docs.status.published": "Publicado",
    // Threat Intelligence extra keys
    "threat.new_intel": "Nueva Inteligencia de Amenazas",
    "threat.new_intel_desc": "Registrar una nueva observación de amenaza o reporte de inteligencia",
    "threat.name_label": "Nombre",
    "threat.category_label": "Categoría",
    "threat.severity_label": "Severidad",
    "threat.source_label": "Fuente",
    "threat.description_label": "Descripción",
    "threat.iocs_label": "IOCs (Indicadores de Compromiso)",
    "threat.iocs_ph": "IP, hash, dominio...",
    "threat.mitre_label": "Tecnicas MITRE ATT&CK",
    "threat.frameworks_label": "Marcos Relevantes",
    "threat.create_btn": "Crear Intel",
    "threat.search_ph": "Buscar inteligencia de amenazas...",
    "threat.all_severity": "Todas las Severidades",
    "threat.all_categories": "Todas las Categorías",
    "threat.all_frameworks": "Todos los Marcos",
    "threat.total_intel": "Total de Intel",
    "threat.active_threats": "Amenazas Activas",
    "threat.tab_dashboard": "Panel", "threat.tab_registry": "Registro de Intel",
    "threat.tab_mitre": "MITRE ATT&CK", "threat.tab_threats": "Amenazas Globales",
    "threat.by_severity": "Por Severidad", "threat.by_category": "Por Categoría",
    "threat.no_data": "Sin datos aun",
    "threat.no_intel": "Sin inteligencia de amenazas aun", "threat.no_results": "Ningun resultado coincide con los filtros",
    "threat.status_label": "Estado",
    "threat.source_label_detail": "Fuente", "threat.iocs_detail": "IOCs",
    "threat.mitre_detail": "MITRE ATT&CK", "threat.created": "Creado",
    "threat.known_threats": "Amenazas Conocidas", "threat.known_vulns": "Vulnerabilidades Conocidas",
    // Threat categories (UI)
    "threat.cat.malware": "Malware", "threat.cat.social_engineering": "Ingenieria Social",
    "threat.cat.network": "Red", "threat.cat.human": "Humano",
    "threat.cat.data": "Datos", "threat.cat.third_party": "Tercero",
    "threat.cat.vulnerability": "Vulnerabilidad", "threat.cat.apt": "APT",
    // Threat sources
    "threat.src.internal": "Interno", "threat.src.osint": "OSINT",
    "threat.src.vendor": "Proveedor", "threat.src.government": "Gobierno",
    "threat.src.industry": "Industria",
    // Evidence extra keys
    "evid.total": "Total de Evidencias", "evid.pending_review": "Pendiente de Revisión",
    "evid.approved": "Aprobado", "evid.linked_controls": "Vinculado a Controles",
    "evid.search_ph": "Buscar evidencias...",
    "evid.all_types": "Todos los Tipos", "evid.all_statuses": "Todos los Estados",
    "evid.add_sheet_title": "Agregar Evidencia",
    "evid.add_sheet_desc": "Crear un nuevo registro de evidencia para controles de cumplimiento",
    "evid.title_label": "Titulo", "evid.type_label": "Tipo de Evidencia",
    "evid.period_label": "Periodo Cubierto", "evid.framework_label": "Marco",
    "evid.link_controls": "Vincular a Controles", "evid.control_search": "Buscar controles...",
    "evid.desc_label": "Descripción", "evid.create_btn": "Crear Evidencia",
    "evid.no_evidence_title": "Aun no hay evidencias recopiladas",
    "evid.no_evidence_desc": "Adjunta capturas, configuraciones, logs y reportes — los auditores lo agradecen.",
    "evid.add_first": "Agregar tu primera evidencia",
    "evid.file_attached": "Archivo adjunto",
    "evid.linked_count": "controles vinculados",
    "evid.period_label_detail": "Periodo",
    "evid.added": "Agregado",
    "evid.delete_title": "Eliminar Evidencia",
    "evid.delete_desc": "Estas seguro de que deseas eliminar esta evidencia? Esta acción no se puede deshacer.",
    "evid.update_status": "Actualizar estado",
    "evid.ph_title": "ej., Captura de Pantalla de Política de Control de Acceso",
    "evid.ph_period": "ej., T1 2024, Ene-Mar 2024",
    // Evidence types
    "evid.type.screenshot": "Captura de Pantalla", "evid.type.document": "Documento",
    "evid.type.log": "Exportación de Log", "evid.type.config": "Configuración",
    "evid.type.certificate": "Certificado", "evid.type.contract": "Contrato",
    "evid.type.interview": "Registro de Entrevista", "evid.type.incident": "Registro de Incidente",
    "evid.type.threat_report": "Reporte de Amenaza",
    // Evidence review statuses
    "evid.status.pending": "Pendiente de Revisión", "evid.status.reviewed": "Revisado",
    "evid.status.approved": "Aprobado", "evid.status.rejected": "Rechazado",
    // EvidenceCollection (auto-cloud) keys
    "ec.page_desc": "Conecta AWS, Azure, GCP, GitHub u Okta para escanear configuraciones de seguridad y recopilar evidencias mapeadas a controles ISO 27001.",
    "ec.load_failed": "Error cargando datos",
    "ec.field_required": "es obligatorio",
    "ec.creds_saved": "Credenciales guardadas",
    "ec.save_failed": "Error al guardar",
    "ec.validation_failed": "Validación fallida",
    "ec.delete_confirm": "¿Eliminar credenciales?",
    "ec.delete_title": "Eliminar credenciales",
    "ec.deleted": "Eliminado",
    "ec.delete_failed": "Error al eliminar",
    "ec.scan_failed": "Escaneo fallido",
    "ec.detail_failed": "Error cargando detalle",
    "ec.page_title": "Auditoría Automática en la Nube",
    "ec.providers_label": "Proveedores",
    "ec.connected_label": "Conectados",
    "ec.scans_label": "Escaneos ejecutados",
    "ec.findings_label": "Hallazgos críticos",
    "ec.tab_connectors": "Conectores",
    "ec.tab_history": "Historial de escaneos",
    "ec.badge_connected": "CONECTADO",
    "ec.badge_live": "Escaneo real",
    "ec.evidence_types": "Evidencias",
    "ec.last_scan": "Último escaneo",
    "ec.btn_edit": "Editar",
    "ec.btn_connect": "Conectar",
    "ec.btn_scanning": "Escaneando…",
    "ec.btn_scan": "Escanear",
    "ec.no_scans": "Aún no hay escaneos. Ejecuta uno desde la pestaña Conectores.",
    "ec.total_label": "Total",
    "ec.badge_saved": "Guardado",
    "ec.placeholder_set": "•••• (guardado)",
    "ec.provider_docs": "Documentación del proveedor",
    "ec.btn_delete": "Eliminar",
    "ec.btn_test": "Probar",
    "ec.btn_save": "Guardar",
    "ec.scan_results": "Resultados del escaneo",
    "ec.compliant": "Cumple",
    "ec.non_compliant": "No cumple",
    "ec.warnings": "Avisos",
    "ec.remediation": "Remediación:",
    "ec.aws_ok": "AWS OK — Cuenta",
    "ec.creds_desc": "Las credenciales se almacenan cifradas a nivel organización y solo el owner puede editarlas.",
    "ec.owner_only": "Solo el owner puede guardar credenciales.",
    // Audits extra keys
    "audits.frameworks_label": "Marcos",
    "audits.scope_label": "Descripción del Alcance",
    "audits.lead_label": "Auditor Lider",
    "audits.start_date": "Fecha de Inicio", "audits.end_date": "Fecha de Fin",
    "audits.create_btn": "Crear Auditoría",
    "audits.search_ph": "Buscar auditorías...",
    "audits.no_audits_title": "Aun no hay auditorías",
    "audits.no_audits_desc": "Planifica y rastrea tus auditorías internas de cumplimiento.",
    "audits.tab_audits": "Auditorías", "audits.tab_nc": "No Conformidades",
    "audits.summary_title": "Resumen de Auditoría",
    "audits.generate_checklist": "Generar Lista con IA",
    "audits.generating": "Generando...",
    "audits.nc_title": "No Conformidades",
    "audits.nc_type_label": "Tipo", "audits.nc_desc_label": "Descripción",
    "audits.nc_root_cause": "Causa Raiz", "audits.nc_corrective": "Acción Correctiva",
    "audits.nc_assigned_to": "Asignado A", "audits.nc_due_date": "Fecha de Vencimiento",
    "audits.nc_create_btn": "Agregar No Conformidad",
    "audits.status.planned": "Planificada", "audits.status.in_progress": "En Progreso",
    "audits.status.completed": "Completada", "audits.status.cancelled": "Cancelada",
    "audits.nc.minor": "NC Menor", "audits.nc.major": "NC Mayor",
    "audits.nc.opportunity": "Oportunidad de Mejora",
    "audits.checklist.not_assessed": "No Evaluado", "audits.checklist.compliant": "Conforme",
    "audits.checklist.non_compliant": "No Conforme", "audits.checklist.observation": "Observación",
    "audits.checklist.not_applicable": "No Aplica",
    "audits.new_title": "Nueva Auditoría Interna", "audits.new_desc": "Programar una nueva auditoría de cumplimiento",
    "audits.delete_title": "Eliminar Auditoría", "audits.delete_desc": "Esto eliminará permanentemente la auditoría y todos sus hallazgos.",
    // S16a-2: i18n sweep ES — legacy strings via t() + corrección tipográfica
    "audits.delete_confirm": "¿Eliminar esta auditoría? Esta acción no se puede deshacer.",
    "audits.toast.title_required": "Por favor ingresa un título para la auditoría",
    "audits.toast.created": "Programa de auditoría creado",
    "audits.toast.create_failed": "Error al crear la auditoría",
    "audits.toast.checklist_failed": "Error al generar la lista de verificación",
    "audits.toast.status_updated": "Estado actualizado a {status}",
    "audits.toast.status_failed": "Error al actualizar el estado",
    "audits.toast.item_failed": "Error al actualizar el ítem de la lista",
    "audits.toast.desc_required": "Por favor ingresa una descripción",
    "audits.toast.nc_created": "No conformidad creada",
    "audits.toast.nc_failed": "Error al crear la no conformidad",
    "audits.toast.plan_saved": "Plan de auditoría guardado",
    "audits.toast.plan_failed": "Error al guardar el plan de auditoría",
    "audits.toast.execution_started": "Ejecución de auditoría iniciada",
    "audits.toast.execution_failed": "Error al iniciar la ejecución",
    "audits.toast.finding_created": "Hallazgo registrado",
    "audits.toast.finding_failed": "Error al registrar el hallazgo",
    "audits.toast.finalized": "Auditoría finalizada",
    "audits.toast.finalize_failed": "Error al finalizar la auditoría",
    "audits.toast.closed": "Auditoría cerrada formalmente",
    "audits.toast.close_failed": "Error al cerrar la auditoría",
    "audits.log_nc_btn": "Registrar NC",
    "audits.checklist_count": "{count} ítems en la lista",
    "audits.nc_assigned": "Asignado: {name}",
    "audits.nc_due": "Vence: {date}",
    "audits.no_ncs_title": "Sin no conformidades",
    "audits.no_ncs_desc": "Limpio. Las NC registradas en auditorías aparecerán aquí.",
    "audits.lead_inline": "Auditor líder: {name}",
    "audits.change_status": "Cambiar Estado",
    "audits.add_nc_inline": "Agregar NC",
    "audits.summary": "Resumen de Auditoría",
    "audits.summary.compliant": "Conforme",
    "audits.summary.non_compliant": "No Conforme",
    "audits.summary.observation": "Observación",
    "audits.summary.na": "N/A",
    "audits.summary.compliance_rate": "Cumplimiento",
    "audits.checklist_header": "Lista de Verificación ({count} ítems)",
    "audits.nc.log_title": "Registrar No Conformidad",
    "audits.nc.log_desc": "Registra una no conformidad u oportunidad de mejora",
    "audits.nc.type": "Tipo de NC",
    "audits.nc.desc": "Descripción",
    "audits.nc.root_cause": "Causa Raíz",
    "audits.nc.action": "Acción Correctiva",
    "audits.nc.assigned": "Asignado A",
    "audits.nc.due": "Fecha de Vencimiento",
    "audits.nc.desc_ph": "Describe la no conformidad...",
    "audits.nc.cause_ph": "¿Qué causó este problema?",
    "audits.nc.action_ph": "¿Qué debe hacerse para corregirlo?",
    "audits.nc.create_btn": "Crear NC",
    "audits.title_ph": "ej., Auditoría Interna ISO 27001 Q1 2024",
    "audits.lead_ph": "ej., Juan Pérez",
    // S16a-2: fases ISO 19011
    "audits.phase.initiation": "Iniciación",
    "audits.phase.preparation": "Preparación",
    "audits.phase.execution": "Ejecución",
    "audits.phase.reporting": "Reporte",
    "audits.phase.followup": "Seguimiento",
    "audits.phase.closed": "Cerrada",
    // S16a-2: tabs
    "audits.tab.plan": "Plan",
    "audits.tab.checklist": "Lista de Verificación",
    "audits.tab.findings": "Hallazgos",
    "audits.tab.report": "Reporte",
    "audits.tab.followup": "Seguimiento",
    // S16a-2: tab Plan
    "audits.plan.objectives_label": "Objetivos de la Auditoría",
    "audits.plan.criteria_label": "Criterios de Auditoría",
    "audits.plan.competence_label": "Competencia del Equipo Auditor",
    "audits.plan.plan_label": "Plan de Auditoría",
    "audits.plan.opening_notes": "Notas de Reunión de Apertura",
    "audits.plan.objectives_ph": "Lo que esta auditoría busca demostrar...",
    "audits.plan.criteria_ph": "Normas, políticas y regulaciones contra las que se evalúa...",
    "audits.plan.competence_ph": "Calificaciones del auditor y experiencia relevante...",
    "audits.plan.plan_ph": "Cronograma, actividades y asignaciones de la auditoría...",
    "audits.plan.opening_notes_ph": "Actas de la reunión de apertura...",
    "audits.plan.save_btn": "Guardar Plan",
    "audits.plan.no_objectives": "Sin objetivos definidos",
    "audits.plan.no_plan": "Sin plan de auditoría definido",
    "audits.plan.no_criteria": "Sin criterios definidos",
    "audits.plan.scope_label": "Alcance",
    "audits.plan.frameworks_label": "Marcos de Referencia",
    "audits.plan.lead_label": "Auditor Líder",
    "audits.plan.team_label": "Equipo",
    "audits.plan.start_execution_btn": "Iniciar Ejecución",
    "audits.plan.finalize_btn": "Finalizar Auditoría",
    "audits.plan.close_btn": "Cerrar Auditoría",
    "audits.plan.closure_statement_label": "Declaración de Cierre",
    "audits.plan.closure_statement_ph": "Declaración que confirma la finalización de la auditoría...",
    // S16a-2: tab Checklist
    "audits.checklist.show_context": "Ver Contexto",
    "audits.checklist.hide_context": "Ocultar Contexto",
    "audits.checklist.guidance_label": "Guía de Implementación",
    "audits.checklist.evidence_required_label": "Evidencia Requerida",
    "audits.checklist.no_context": "Sin contexto disponible — regenerar lista de verificación",
    "audits.checklist.regenerate_btn": "Regenerar Lista",
    "audits.checklist.locale_badge": "Idioma",
    "audits.checklist.add_finding_btn": "Registrar Hallazgo",
    "audits.checklist.filter_all": "Todos los Resultados",
    "audits.checklist.filter_framework": "Todos los Marcos",
    "audits.checklist.search_ph": "Buscar controles...",
    // S16a-2: tab Hallazgos
    "audits.findings.add": "Registrar Hallazgo",
    "audits.findings.none": "Aún no hay hallazgos registrados",
    "audits.findings.none_desc": "Registra hallazgos desde la lista de verificación al evaluar controles.",
    "audits.findings.control": "Control",
    "audits.findings.type": "Tipo",
    "audits.findings.severity": "Severidad",
    "audits.findings.description": "Descripción",
    "audits.findings.evidence": "Fuentes de Evidencia",
    "audits.findings.type.conformity": "Conformidad",
    "audits.findings.type.nonconformity": "No Conformidad",
    "audits.findings.type.opportunity": "Oportunidad de Mejora",
    "audits.findings.type.observation": "Observación",
    "audits.findings.severity_minor": "Menor",
    "audits.findings.severity_major": "Mayor",
    "audits.findings.log_title": "Registrar Hallazgo de Auditoría",
    "audits.findings.log_desc": "Documenta lo observado para este control",
    "audits.findings.type_label": "Tipo de Hallazgo",
    "audits.findings.desc_ph": "Describe lo que fue observado...",
    "audits.findings.nc_linked": "NC Vinculada",
    // S16a-2: tab Reporte
    "audits.report.generate_docx": "Generar Reporte (.docx)",
    "audits.report.generate_pdf": "Generar Reporte (.pdf)",
    "audits.report.distribute": "Distribuir Reporte",
    "audits.report.not_available": "Generación de reporte disponible en S16a-3",
    // S16a-2: cierre y seguimiento
    "audits.close.statement_label": "Declaración de Cierre",
    "audits.close.closed_at": "Cerrada el",
    "audits.close.closed_by": "Cerrada por",
    "audits.followup.next_review": "Próxima Revisión",
    "audits.followup.effectiveness": "Revisión de Eficacia",
    "audits.followup.none": "Aún no hay acciones de seguimiento",
    // C13: modal nueva acción + inline-edit
    "audits.followup.new": "Nueva acción",
    "audits.followup.created": "Acción creada",
    "audits.followup.create_failed": "Error al crear la acción",
    "audits.followup.updated": "Acción actualizada",
    "audits.followup.update_failed": "Error al actualizar la acción",
    "audits.followup.no_nonconformities": "Sin no-conformidades — no se pueden crear acciones sin una",
    "audits.followup.save": "Guardar",
    "audits.followup.cancel": "Cancelar",
    "audits.followup.fields.description": "Descripción",
    "audits.followup.fields.responsible": "Responsable",
    "audits.followup.fields.due_date": "Fecha de vencimiento",
    "audits.followup.fields.status": "Estado",
    "audits.followup.fields.notes": "Notas",
    "audits.followup.fields.non_conformity": "No-conformidad",
    "audits.followup.fields.non_conformity_placeholder": "Seleccionar NC relacionada",
    "audits.followup.nc_required": "Debe seleccionar una no-conformidad",
    "audits.followup.errors.description_required": "La descripción es obligatoria",
    "audits.followup.status.pending": "Pendiente",
    "audits.followup.status.in_progress": "En progreso",
    "audits.followup.status.verified": "Verificado",
    "audits.followup.status.closed": "Cerrado",
    "audits.back_to_audits": "Volver a Auditorías",
    "audits.open_detail": "Ver Detalle",
    // Corrective Actions extra keys
    "ca.search_ph": "Buscar acciones correctivas...", "ca.all_statuses": "Todos los Estados",
    "ca.all_priorities": "Todas las Prioridades",
    "ca.open": "Abierto", "ca.overdue": "Vencido", "ca.total": "Total",
    "ca.source_label": "Fuente", "ca.desc_label": "Descripción",
    "ca.priority_label": "Prioridad", "ca.owner_label": "Responsable",
    "ca.due_date_label": "Fecha de Vencimiento", "ca.create_btn": "Crear Acción",
    "ca.no_actions_title": "Aun no hay acciones correctivas",
    "ca.no_actions_desc": "Las acciones correctivas rastrean no conformidades y mejoras.",
    "ca.source.audit": "Auditoría", "ca.source.risk_review": "Revisión de Riesgos",
    "ca.source.incident": "Incidente", "ca.source.management_review": "Revisión por la Dirección",
    "ca.source.other": "Otro",
    "ca.new_title": "Nueva Acción Correctiva", "ca.new_desc": "Crear una nueva acción correctiva",
    "ca.status.open": "Abierto", "ca.status.in_progress": "En Progreso",
    "ca.status.closed": "Cerrado", "ca.status.overdue": "Vencido",
    "ca.toast.desc_required": "La descripción es obligatoria",
    "ca.toast.created": "Acción correctiva creada",
    "ca.toast.create_failed": "Error al crear la acción correctiva",
    "ca.toast.status_updated": "Estado actualizado",
    "ca.toast.status_failed": "Error al actualizar el estado",
    "ca.toast.effectiveness_saved": "Revisión de efectividad guardada",
    "ca.toast.effectiveness_failed": "Error al guardar la revisión de efectividad",
    // Vendor Risk extra keys
    "vendor.search_ph": "Buscar proveedores...",
    "vendor.name_label": "Nombre del Proveedor", "vendor.category_label": "Categoría",
    "vendor.contact_name_label": "Nombre del Contacto", "vendor.contact_email_label": "Correo del Contacto",
    "vendor.services_label": "Servicios Proporcionados",
    "vendor.data_access_label": "Nivel de Acceso a Datos",
    "vendor.criticality_label": "Criticidad",
    "vendor.create_btn": "Agregar Proveedor",
    "vendor.no_vendors_title": "Aun no hay proveedores",
    "vendor.no_vendors_desc": "Rastrea proveedores de terceros y sus puntuaciones de riesgo.",
    "vendor.new_title": "Agregar Proveedor", "vendor.new_desc": "Registrar un nuevo proveedor de terceros",
    "vendor.risk_summary": "Resumen de Riesgos",
    "vendor.cat.technology": "Tecnologia", "vendor.cat.cloud": "Nube",
    "vendor.cat.consulting": "Consultoria", "vendor.cat.outsourcing": "Externalización",
    "vendor.access.none": "Ninguno", "vendor.access.limited": "Limitado",
    "vendor.access.significant": "Significativo", "vendor.access.full": "Completo",
    // Management Review extra keys
    "review.create_title": "Programar Revisión por la Dirección",
    "review.create_desc": "Planifica una nueva reunion de revisión por la dirección",
    "review.title_label": "Titulo de la Revisión",
    "review.date_label": "Fecha de Revisión",
    "review.attendees_label": "Asistentes",
    "review.attendee_ph": "Agregar correo del asistente",
    "review.agenda_label": "Puntos de Agenda",
    "review.notes_label": "Notas",
    "review.create_btn": "Programar Revisión",
    "review.no_reviews_title": "No hay revisiones programadas",
    "review.no_reviews_desc": "Las revisiones por la dirección son requeridas por la cláusula 9.3 de ISO 27001.",
    "review.schedule_first": "Programar tu primera revisión",
    "review.status.scheduled": "Programada", "review.status.in_progress": "En Progreso",
    "review.status.completed": "Completada",
    "review.decisions_title": "Decisiones", "review.add_decision": "Agregar Decision",
    "review.action_items_title": "Elementos de Acción", "review.add_action": "Agregar Elemento de Acción",
    "review.action_desc": "Descripción", "review.action_owner": "Responsable",
    "review.action_due": "Fecha de Vencimiento", "review.action_btn": "Agregar",
    // Training extra keys
    "training.cat.awareness": "Concienciación en Seguridad", "training.cat.phishing": "Prevención de Phishing",
    "training.cat.data_protection": "Protección de Datos", "training.cat.incident_response": "Respuesta a Incidentes",
    "training.cat.gdpr": "GDPR/Privacidad", "training.cat.access_control": "Control de Acceso",
    "training.cat.other": "Otro",
    "training.no_programs": "Aun no hay programas de capacitación",
    "training.new_program_title": "Nuevo Programa de Capacitación",
    "training.desc_ph": "Breve descripción...",
    "training.roles": "Roles",
    // Maintenance extra keys
    "maint.total_tasks": "Total de Tareas", "maint.all_status": "Todos los Estados",
    "maint.all_categories": "Todas las Categorías", "maint.search_tasks": "Buscar tareas...",
    "maint.loading": "Cargando tareas de mantenimiento...",
    "maint.next_due": "Proximo vencimiento", "maint.next_due_date": "Fecha de Proximo Vencimiento",
    "maint.task_title": "Titulo de la Tarea", "maint.task_details_ph": "Detalles de la tarea...",
    "maint.assigned_to_ph": "Asignado a...", "maint.new_desc": "Programar una tarea de cumplimiento recurrente",
    "maint.create_task": "Crear Tarea",
    "maint.title_date_required": "Titulo y fecha de vencimiento son requeridos",
    "maint.task_created": "Tarea de mantenimiento creada",
    "maint.create_failed": "Error al crear la tarea",
    "maint.complete_failed": "Error al completar la tarea",
    "maint.status_update_failed": "Error al actualizar estado",
    "maint.task_deleted": "Tarea eliminada",
    "maint.delete_failed": "Error al eliminar la tarea",
    "maint.no_tasks": "No hay tareas de mantenimiento programadas",
    "maint.no_tasks_filter": "Ninguna tarea coincide con tus filtros",
    "maint.schedule_first": "Programar Primera Tarea",
    "maint.resume": "Reanudar", "maint.pause": "Pausar",
    // Gap Analysis extra keys
    "gap.client_project_fw_required": "Cliente, proyecto y marco son obligatorios",
    "gap.project_created_running": "Proyecto GAP creado. Ejecutando evaluación...",
    "gap.assessment_completed": "Evaluación completada",
    "gap.project_marked_completed": "Proyecto marcado como completado",
    "gap.delete_confirm": "Eliminar este proyecto GAP?",
    "gap.delete_title": "Eliminar proyecto GAP",
    "gap.deleted": "Eliminado",
    "gap.finding_saved": "Hallazgo guardado",
    "gap.finding_save_failed": "No se pudo guardar el hallazgo",
    "gap.discard_confirm": "Descartar tus ediciones y volver al calculo automatico?",
    "gap.discard_title": "Descartar ediciones",
    "gap.finding_reverted": "Edición revertida",
    "gap.revert_failed": "Error al revertir",
    "gap.edit_finding": "Editar hallazgo",
    "gap.owner_ph": "Nombre o rol",
    "gap.target_date": "Fecha objetivo",
    "gap.notes_comments": "Notas / Comentarios",
    "gap.notes_ph": "Observaciones del auditor o estado actual...",
    "gap.remediation_plan": "Plan de remediación",
    "gap.remediation_ph": "Acciones, hitos y entregables para cerrar la brecha...",
    "gap.linked_evidence": "Evidencias enlazadas",
    "gap.no_evidence_repo": "No hay evidencias en el repositorio. Súbelas en el módulo Evidence.",
    "gap.linked_documents": "Documentos enlazados",
    "gap.no_docs_published": "No hay documentos publicados.",
    "gap.revert": "Revertir",
    "gap.saving": "Guardando...",
    "gap.save_finding": "Guardar hallazgo",
    "gap.findings": "Hallazgos",
    "gap.due_label": "Vence",
    "gap.evidences": "evidencias",
    "gap.documents": "documentos",
    // Policy Generator extra keys
    "pol.tab_templates": "Plantillas Pre-Construidas", "pol.tab_ai": "Generador IA",
    "pol.template_library_title": "Biblioteca de Plantillas Listas para Auditoría",
    "pol.template_library_desc": "Plantillas pre-construidas por estándar: políticas, procedimientos, formularios y descripciones de puesto. Rellena los campos con el contexto de tu organización, firmante y revisor, y el documento se guardará en el módulo Documentos listo para firmar.",
    "pol.all_frameworks": "Todos los Marcos", "pol.all_types": "Todos los Tipos",
    "pol.templates_available": "plantillas disponibles",
    "pol.no_templates": "No hay plantillas con estos filtros.",
    "pol.use_template": "Usar Plantilla",
    "pol.generate_ai_title": "Generar con IA desde un Control",
    "pol.control_label": "Control", "pol.choose_control": "Elige un control",
    "pol.generate_with_ai": "Generar con IA",
    "pol.edit_mode": "MODO EDICION",
    "pol.edit_before_save": "Edita el contenido antes de guardar",
    "pol.discard": "Descartar", "pol.saving": "Guardando...",
    "pol.save_to_docs": "Guardar en Documentos",
    "pol.chars_hint": "caracteres · Los cambios se guardarán cuando hagas clic en \"Guardar en Documentos\"",
    "pol.discard_confirm": "Descartar cambios y cerrar?",
    "pol.discard_title": "Descartar cambios",
    "pol.saved_to_docs": "Guardado en Documentos",
    "pol.view": "Ver",
    "pol.doc_generated": "Documento generado. Edita y guarda cuando este listo.",
    "pol.generate_error_fallback": "La generación fallo. Por favor intenta de nuevo.",
    "pol.approver_reviewer_required": "Firmante y revisor son requeridos",
    "pol.fill_dialog_desc": "Rellena el contexto de la organización. El documento quedara en estado 'borrador' en Documentos, listo para revisión y firma.",
    "pol.org_name_label": "Nombre Organización", "pol.address_label": "Dirección",
    "pol.version_label": "Versión", "pol.classification_label": "Clasificación",
    "pol.effective_date_label": "Fecha Vigencia", "pol.next_review_label": "Proxima Revisión",
    "pol.approver_signer": "Firmante (Aprobador)", "pol.role_label": "Rol",
    "pol.reviewer": "Responsable de Revisión",
    "pol.extra_context_label": "Contexto Adicional (opcional)",
    "pol.extra_context_ph": "Información especifica de tu organización a incluir al final del documento...",
    "pol.generate_and_save": "Generar y Guardar",
    "pol.export_failed": "Error al exportar el documento. Por favor intenta de nuevo.",
    // Policy Generator doc types
    "pol.doctype.policy": "Política", "pol.doctype.procedure": "Procedimiento",
    "pol.doctype.form": "Formulario", "pol.doctype.job_description": "Descripción de Puesto",
    "pol.doctype.guideline": "Guía", "pol.doctype.checklist": "Checklist",
    // Reports extra keys
    "rep.loading": "Cargando datos del reporte...",
    "rep.generating": "Generando...",
    "rep.export_success": "Reporte exportado exitosamente",
    "rep.export_failed": "Error al exportar PDF",
    "rep.download_pdf": "Descargar Reporte PDF",
    "rep.compliance_overview": "Vision General de Cumplimiento",
    "rep.compliance_overview_desc": "Postura de cumplimiento actual en todos los marcos",
    "rep.overall_score": "Puntuación General", "rep.health_score": "Índice de Salud",
    "rep.generated_at": "Reporte generado a las",
    // Executive Report extra keys
    "exec.general_desc": "Resumen ejecutivo integral",
    "exec.risk_desc": "Enfoque en riesgos y progreso de tratamiento",
    "exec.compliance_desc": "Puntuaciones, brechas, preparación para certificación",
    "exec.incidents_desc": "Tendencias de incidentes y respuesta",
    "exec.improvement_desc": "ACs, KPIs, mejora continua",
    "exec.report_generated": "Reporte ejecutivo generado",
    "exec.generation_failed": "Error al generar",
    "exec.generate_report": "Generar Reporte",
    "exec.compliance_label": "Cumplimiento",
    "exec.health_label": "Salud",
    "exec.critical_risks": "Riesgos Criticos",
    "exec.preparing": "La IA esta preparando tu reporte para directivos...",
    "exec.select_focus": "Selecciona un area de enfoque y genera",
    "exec.ai_translates": "La IA traduce metricas de cumplimiento a lenguaje ejecutivo",
    // Benchmarking extra keys
    "bench.your_score": "Tu Puntuación",
    // Wizard extra keys
    "wizard.phase": "Fase", "wizard.phases_label": "fases",
    "wizard.controls_label": "controles",
    "wizard.loading": "Cargando asistente...",
    "wizard.implementation": "Implementación",
    "wizard.ai_guide_desc": "El experto IA te guiara en cada paso con consejos practicos, plantillas y sugerencias de evidencia",
    "wizard.analyzing": "Analizando...",
    "wizard.ask_about_phase": "Pregunta sobre la Fase",
    "wizard.select_phase_left": "Selecciona una fase a la izquierda para comenzar",
    "wizard.start_phase": "Iniciar", "wizard.complete_phase": "Completar",
    "wizard.marked_as": "marcada como",
    "wizard.status_update_failed": "Error al actualizar estado",
    // Engagements extra keys
    "eng.client_project_required": "Cliente y proyecto son obligatorios",
    "eng.project_created_running": "Proyecto creado. Ejecutando snapshot...",
    "eng.snapshot_updated": "Snapshot actualizado",
    "eng.delete_confirm": "Eliminar este proyecto?",
    "eng.delete_title": "Eliminar proyecto",
    "eng.deleted": "Eliminado",
    "eng.switch_confirm_prefix": "Trabajar en el tenant de",
    "eng.switch_confirm_suffix": "? La pagina se recargara.",
    "eng.switch_title": "Cambiar de tenant",
    "eng.context_switched": "Contexto cambiado. Recargando...",
    "eng.no_snapshot": "Sin snapshot",
    "eng.risks_label": "Riesgos", "eng.treated_label": "Tratados",
    "eng.entries_label": "Entradas",
    "eng.projects_label": "proyecto(s)",
    "eng.current_badge": "ACTUAL",
    "eng.open": "Abrir",
    "eng.your_org": "Tu org",
    "eng.create_project_desc": "Crea un proyecto asociado a un cliente (tenant). Los datos se almacenaran en el tenant del cliente.",
    // Common missing
    "name": "Nombre",
    "owner": "Responsable",
    // S14a — Forgot/Reset password
    "auth.forgot.title": "Restablecer contraseña",
    "auth.forgot.email_label": "Correo",
    "auth.forgot.submit": "Enviar enlace",
    "auth.forgot.generic_response": "Si el correo existe, recibirás un enlace en breve.",
    "auth.forgot.link_in_login": "¿Olvidaste tu contraseña?",
    "auth.forgot.back_to_login": "Volver al inicio de sesión",
    "auth.reset.title": "Elige una nueva contraseña",
    "auth.reset.new_password": "Nueva contraseña",
    "auth.reset.confirm_password": "Confirmar contraseña",
    "auth.reset.submit": "Guardar",
    "auth.reset.invalid_token": "Enlace inválido o vencido",
    "auth.reset.invalid_token_desc": "Solicita un nuevo enlace para restablecer tu contraseña.",
    "auth.reset.success": "Contraseña actualizada. Inicia sesión.",
    "auth.reset.passwords_no_match": "Las contraseñas no coinciden",
    "auth.reset.request_new": "Solicitar nuevo enlace",
    // B12 S16b-2 — Aviso 2FA tras restablecimiento de contraseña exitoso
    "auth.reset.2fa_banner.title": "Aviso sobre 2FA",
    "auth.reset.2fa_banner.body": "Si tienes 2FA activado y perdiste el dispositivo, contacta a soporte para que un administrador desactive 2FA tras verificar tu identidad.",
    "auth.reset.success_heading": "Contraseña actualizada",
    "auth.reset.success_desc": "Tu contraseña ha sido actualizada. Ya puedes iniciar sesión.",
    "auth.reset.go_to_signin": "Iniciar sesión",
    // S14a — Platform Admin org/user CRUD
    "platform_admin.orgs.create": "Nuevo tenant",
    "platform_admin.orgs.suspend": "Suspender",
    "platform_admin.orgs.reactivate": "Reactivar",
    "platform_admin.orgs.delete": "Eliminar (soft)",
    "platform_admin.orgs.restore": "Restaurar",
    "platform_admin.orgs.delete_confirm": "Para confirmar, escribe el nombre del tenant: {name}",
    "platform_admin.orgs.delete_warning": "Esta acción es reversible hasta 30 días. Los datos se conservan pero el acceso queda bloqueado.",
    "platform_admin.orgs.restore_confirm": "¿Restaurar esta organización y reactivar el acceso?",
    "platform_admin.users.reset_pwd": "Resetear contraseña",
    "platform_admin.users.reset_sent": "Se envió un enlace a {email}",
    "platform_admin.users.reset_confirm": "¿Enviar enlace de restablecimiento a {email}? El admin no verá la nueva contraseña.",
    // S14a — Audit log
    "platform_admin.audit.title": "Registro de auditoría",
    "platform_admin.audit.export_csv": "Exportar CSV",
    "platform_admin.audit.filter_action": "Acción",
    "platform_admin.audit.filter_actor": "Actor",
    "platform_admin.audit.filter_target": "Objetivo",
    "platform_admin.audit.filter_from": "Desde",
    "platform_admin.audit.filter_to": "Hasta",
    "platform_admin.audit.open_full": "Abrir página completa",
    "platform_admin.audit.recent_activity": "Actividad reciente",
    // S14b — 2FA TOTP
    "auth.2fa.setup.title": "Autenticación en dos pasos",
    "auth.2fa.setup.intro_title": "Protege tu cuenta",
    "auth.2fa.setup.intro_desc": "La autenticación en dos pasos añade una capa extra de seguridad.",
    "auth.2fa.setup.step1": "Escanea el código QR con Google Authenticator (o cualquier app TOTP).",
    "auth.2fa.setup.step2": "Ingresa el código de 6 dígitos que muestra la app",
    "auth.2fa.setup.step3": "Guarda estos códigos de recuperación. Cada uno funciona una sola vez.",
    "auth.2fa.setup.step_label_1": "Escanear",
    "auth.2fa.setup.step_label_2": "Verificar",
    "auth.2fa.setup.step_label_3": "Recuperación",
    "auth.2fa.setup.scan_title": "Escanear código QR",
    "auth.2fa.setup.manual_secret": "¿No puedes escanear? Ingresa este código manualmente:",
    "auth.2fa.setup.verify_button": "Verificar código",
    "auth.2fa.setup.recovery_title": "Guardar códigos de recuperación",
    "auth.2fa.setup.download_codes": "Descargar códigos (TXT)",
    "auth.2fa.setup.codes_copied": "Códigos copiados al portapapeles",
    "auth.2fa.setup.confirm_saved": "He guardado mis códigos de recuperación en un lugar seguro",
    "auth.2fa.setup.finish": "Finalizar",
    "auth.2fa.setup.finish_success": "Autenticación en dos pasos activada.",
    "auth.2fa.setup.begin": "Comenzar configuración",
    "auth.2fa.setup.activated": "2FA activado",
    "auth.2fa.setup.invalid_code": "Código inválido. Intenta nuevamente.",
    "auth.2fa.setup.code_required": "Ingresa el código de 6 dígitos.",
    "auth.2fa.setup.error_setup": "No se pudo iniciar la configuración. Intenta nuevamente.",
    "auth.2fa.status.active": "2FA activo",
    "auth.2fa.status.active_desc": "Tu cuenta está protegida con autenticación en dos pasos.",
    "auth.2fa.disable.title": "Desactivar 2FA",
    "auth.2fa.disable.warning": "Tu cuenta quedará menos protegida.",
    "auth.2fa.disable.password_label": "Contraseña actual",
    "auth.2fa.disable.password_placeholder": "Tu contraseña",
    "auth.2fa.disable.code_label": "Código de verificación",
    "auth.2fa.disable.code_placeholder": "Código de 6 dígitos o código de recuperación",
    "auth.2fa.disable.code_hint": "Ingresa tu código TOTP o un código de recuperación (XXXXXXXX-XXXXXXXX).",
    "auth.2fa.disable.button": "Desactivar 2FA",
    "auth.2fa.disable.fields_required": "Contraseña y código son obligatorios.",
    "auth.2fa.disable.success": "Autenticación en dos pasos desactivada.",
    "auth.2fa.disable.error": "No se pudo desactivar 2FA. Verifica tus credenciales.",
    "auth.2fa.banner.text": "Protege tu cuenta con autenticación en dos pasos",
    "auth.2fa.banner.cta": "Activar ahora",
    "auth.2fa.banner.dismiss": "Recordar después",
    "auth.2fa.challenge.title": "Verificación en dos pasos",
    "auth.2fa.challenge.code_label": "Código de 6 dígitos",
    "auth.2fa.challenge.recovery_label": "Código de recuperación",
    "auth.2fa.challenge.use_recovery": "Usar código de recuperación",
    "auth.2fa.challenge.use_totp": "Usar código de la app autenticadora",
    "auth.2fa.challenge.expires_in": "Expira en {seconds}",
    "auth.2fa.challenge.verify": "Verificar",
    "auth.2fa.challenge.back_to_login": "Volver al inicio de sesión",
    "auth.2fa.challenge.expired": "Sesión expirada. Por favor inicia sesión nuevamente.",
    "auth.2fa.challenge.invalid_code": "Código inválido. Intenta nuevamente.",
    "auth.2fa.challenge.code_required": "Ingresa el código de 6 dígitos.",
    "auth.2fa.challenge.recovery_required": "Ingresa tu código de recuperación.",
    "auth.2fa.challenge.too_many_attempts": "Demasiados intentos. Por favor inicia sesión nuevamente.",
    "auth.2fa.challenge.recovery_low": "Solo quedan {n} códigos de recuperación. Genéralos nuevamente en Configuración.",
    "common.loading": "Cargando...",
    "common.copy": "Copiar",
    "common.save": "Guardar",
    // S17b — Framework Picker (ADR-S17b-003)
    "settings.frameworks.title": "Frameworks activos",
    "settings.frameworks.subtitle": "Elige qué normas usa tu organización.",
    "settings.frameworks.counter_suffix": "frameworks activos",
    "settings.frameworks.over_cap_badge": "Excede el límite",
    "settings.frameworks.over_cap": "Excedes tu plan en {excess}. Quita frameworks o sube de plan.",
    "settings.frameworks.upgrade_cta": "Subir de plan",
    "settings.frameworks.read_only": "Solo el propietario o administrador de la organización puede cambiar la selección de frameworks.",
    "settings.frameworks.saved": "Frameworks actualizados",
    "settings.frameworks.save_failed": "No se pudo guardar la selección de frameworks",
    "settings.frameworks.load_failed": "No se pudo cargar los datos de frameworks",
    "settings.frameworks.help_text": "Los frameworks de referencia (NIST CSF 2.0, ISO 31000, ISO 22301) están siempre activos y no consumen cupo de tu plan.",
    "settings.frameworks.billing_link": "Gestionar plan",
    "settings.frameworks.locked_reference_badge": "Referencia (incluido)",
    "settings.frameworks.group_core": "Cumplimiento IT",
    "settings.frameworks.group_rd_latam": "Gobierno RD (NORTIC)",
    "settings.frameworks.group_sectorial": "Sectores regulados (Banca, Telecom)",
    "settings.frameworks.group_zona_franca": "Zona Franca",
    "settings.frameworks.group_reference": "Referencias cross-mapping",
    // P0-B (OBS-018) — Register Wizard bilingue onboarding (T5)
    "register.full_name_placeholder": "María Pérez",
    "register.email_placeholder": "tu@empresa.com",
    "register.password_placeholder": "Al menos 10 caracteres",
    "register.show_password": "Mostrar contraseña",
    "register.hide_password": "Ocultar contraseña",
    "register.pwd_check_length": "10-128 caracteres",
    "register.pwd_check_classes": "3 de: minúsculas, mayúsculas, dígitos, símbolos",
    "register.org_name_placeholder": "Ejemplo, S.R.L.",
    "register.business_type": "Tipo de negocio",
    "register.internal_team": "Equipo interno",
    "register.internal_team_desc": "Usamos ComplianceOS para nuestra propia organización",
    "register.consultant_mssp": "Consultor / MSSP",
    "register.consultant_mssp_desc": "Gestionamos el cumplimiento de múltiples clientes",
    "register.industry": "Industria (opcional)",
    "register.industry_placeholder": "ej. FinTech",
    "register.country": "País (opcional)",
    "register.country_placeholder": "ej. RD",
    "register.standards_label": "Normas a habilitar",
    "register.standards_hint": "Elige los marcos que necesita tu organización. Puedes cambiar esto luego.",
    "register.expected_users": "Usuarios esperados",
    "register.expected_users_hint": "Se usa para recomendar un plan y calcular el precio de tu suscripción.",
    "register.price.estimated_plan": "Plan Profesional estimado",
    "register.price.base": "Base",
    "register.price.includes": "Incluye",
    "register.price.and": "y",
    "register.price.extra_standard_one": "{n} norma adicional",
    "register.price.extra_standard_other": "{n} normas adicionales",
    "register.price.extra_user_one": "{n} usuario adicional",
    "register.price.extra_user_other": "{n} usuarios adicionales",
    "register.price.standard_one": "{n} norma",
    "register.price.standard_other": "{n} normas",
    "register.price.users": "{n} usuarios",
    "register.client_tenants": "Tenants de clientes",
    "register.client_tenants_hint": "Cada tenant se convierte en su propia organización con datos y normas aisladas.",
    "register.add_tenant": "Agregar tenant",
    "register.no_tenants_yet": "Aún no hay tenants. Agrega al menos uno para continuar.",
    "register.tenant_number": "Tenant #{n}",
    "register.tenant_name": "Nombre del tenant",
    "register.tenant_name_placeholder": "ej. Globex Corp",
    "register.standards": "Normas",
    "register.create_account": "Crear Cuenta",
    "register.creating_account": "Creando cuenta...",
    "register.legal_disclaimer": "Al crear una cuenta aceptas recibir un correo de confirmación.",
    "register.err_name_required": "El nombre es obligatorio",
    "register.err_email_required": "El correo es obligatorio",
    "register.err_password_requirements": "La contraseña debe tener 10-128 caracteres y usar 3 de: minúsculas, mayúsculas, dígitos, símbolos",
    "register.err_org_required": "El nombre de la organización es obligatorio",
    "register.err_standard_required": "Selecciona al menos una norma",
    "register.err_users_min": "Los usuarios esperados deben ser al menos 1",
    "register.err_tenant_required": "Agrega al menos un tenant cliente",
    "register.err_tenant_name_required": "Todos los tenants deben tener un nombre",
    "register.err_tenant_standard_required": "El tenant \"{name}\" necesita al menos una norma",
    // P0-B (OBS-018) — SoA i18n completion (T6)
    "soa.loading": "Cargando Declaración de Aplicabilidad",
    "soa.all_statuses": "Todos los Estados",
    "soa.showing_of_entries": "Mostrando {x} de {y} registros",
    "soa.no_entries": "No se encontraron registros de SoA",
    "soa.no_entries_hint": "Genera un SoA para un marco para comenzar",
    "soa.mapped": "mapeados",
    "soa.edit_entry": "Editar Registro de SoA",
    "soa.responsible": "Responsable",
    "soa.responsible_placeholder": "ej. Equipo de Seguridad de TI",
    "soa.justification_placeholder": "¿Por qué este control es aplicable/no aplicable?",
    "soa.notes_placeholder": "Notas adicionales de implementación...",
    "soa.cross_framework_mappings": "Mapeos entre Marcos",
    "soa.toast_generate_failed": "Error al generar el SoA",
    "soa.toast_entry_updated": "Registro actualizado",
    "soa.toast_update_failed": "Error al actualizar el registro",
    // P2 — barrido diálogos confirm/prompt (ESignatureSettings/MultiTenancy/Billing/Documents/PlatformAdmin)
    "esig.delete_config_title": "Eliminar configuración",
    "esig.delete_config_desc": "¿Eliminar configuración?",
    "mt.switch_title": "Cambiar de tenant",
    "mt.switch_desc_prefix": "¿Cambiar a",
    "mt.switch_desc_suffix": "? Deberás recargar la página para ver los datos de este cliente.",
    "billing.switch_title": "Cambiar de plan",
    "billing.switch_desc_prefix": "¿Cambiar a",
    "billing.switch_desc_suffix": "? Esta acción actualizará tu suscripción.",
    "docs.publish_title": "Publicar documento",
    "docs.publish_desc_prefix": "¿Publicar",
    "docs.publish_desc_suffix": "? Esto hace el documento definitivo.",
    "docs.review_comment_title": "Enviar a revisión",
    "docs.review_comment_label": "Comentario para el revisor (opcional)",
    "docs.approval_comment_title": "Aprobar documento",
    "docs.approval_comment_label": "Comentario de aprobación (opcional)",
    "padmin.delete_tier_title": "Eliminar plan",
    "padmin.delete_tier_desc_prefix": "¿Eliminar plan",
    "padmin.delete_tier_desc_suffix": "?",
    "padmin.reset_tiers_title": "Restaurar predeterminados",
    "padmin.reset_tiers_desc": "¿Restaurar planes a los 3 predeterminados? Se eliminarán planes no estándar sin suscriptores.",
    "padmin.revoke_admin_title": "Revocar super-admin",
    "padmin.revoke_admin_desc_prefix": "¿Revocar super-admin a",
    "padmin.revoke_admin_desc_suffix": "?",
    "padmin.override_title": "Asignar plan",
    "padmin.override_tier_label": "Plan",
    "padmin.override_price_label": "Precio personalizado mensual (vacío = estándar)",
    "padmin.override_note_label": "Nota",
    "padmin.override_save": "Asignar",
  }
};

export default translations;
